export default {
  reportSet:{
    template:"template",
   username :"username",
   set:'set',
   empty:"no data!",
   reportName:"reportName",
   viewRange: "viewRange",
   isEnabled:"isEnabled",
},
// 代码事件
codeEvent:{
  eventSet:"set event",
  eventName:"eventName",
  eventId:"event ID",
  placeSet:"place set ",
  fieldChange:"fieldChange",
  field:"field",
  status:'status',
  eventContent:'eventContent',
  sqlConfig:"sqlConfig",
  name:'name',
  remark:'remark'

},


// 新增的提示弹框 绑定到vue 中文作为建明 修改太困难了
$message:{
  请选择人员进行数据转交:'Please select the personnel for data transfer!',
  请先添加计划明细:"Please add the plan details",
  该文件暂不支持预览:'This file does not support preview',
  已取消关闭:'cancel',
  请选择数据:"Please select data",
  成功清除缓存:' clear cache Successfully',
  部署成功:'deploy successfully',
'模型名称重复，请使用新名称创建模型。':'model name has already exist!',
'用户名或密码不能为空！':' username or password cannot be empty!'
},

  // 表单配置
  formSet:{
    stretch:'stretch',
    tile:'tile',
    half:'stretch half',
    third:'Take up a third',
    leftJustify: 'jusifycontent-left',
    rightJustify: 'jusifycontent-right',
    center: "jusifycontent-cener",
    equal: 'equal',
    DateRange: 'DateRange',
    less: 'less',
    lessOrequal: 'lessOrequal',
    greater: 'greater',
    greatorequal: "great or equal",
    like: 'like',
    left: 'left',
    right: 'right',
    between: 'between',
    database:'dataBase',
    expression:'custom expression',
    year:'year',
    month:'month',
    day:'day',
    hour:'hour',
    minute:'minute',
    second:'second',
    input:'input box' ,
    dateRange :	 'dateRange' ,
    dateInput:'date input' ,
    selectOption:'select option',
    switch:'switch' ,
    textarea:'text area' ,
    numberInput:'number input' ,
    richText:'rich text' ,
    checkBox: 'check box',
    hyperlink: 'hyperlink',
    cascadeSelector: 'cascadeSelector',
    people: 'people' ,
    citySelect:'city select' ,
    selectInput:'select input',
    permiAll: 'all',
    permiCustom: 'user define',
    department: 'department',
    deptBelow: "department below",
    selfOnly:'self only'
  },



  // 版本
  vversion: {
    record:'Update record',
    log: 'Edit record',
    times:"Update times",
    updateDate:"Update date",
    updatePerson:"Update by",
    mainTableData:'Main datas',
    detailsOldData:'Detail raw data',
    detailsData:'Detail update data',
    oldData:"Raw data",
    newData:"Update data",
    moduleName:"Module name",
    post:"Post",
    put:"Put",
    remove:"Remove",
    get:"Get",
    success:"Successful",
    fail:"Fail",
    business:"Business data",
    other: "Other Data",
    remark: 'remark'
  },
  $confirm:{
    message:{
      修改为已读吗:'confirm change to read?',
      确定撤回该数据吗:'make sure to withdraw this data',
      '是否要变更该合同？':"Do you want to change the contract?",
      '是否要取消变更该合同？':"Do you want to cancel and change the contract?"

    },
    title:{
      "提示":"Tip",

    },
    cancelButtonText:{},
    confirmButtonText:{},

  },


  // 新增的提示弹框 绑定到vue 中文作为建明 修改太困难了
  $message:{
    请选择人员进行数据转交:'Please select the personnel for data transfer!',
    请先添加计划明细:"Please add the plan details",
    该文件暂不支持预览:'This file does not support preview',
    已取消关闭:'cancel',
    请选择数据:"Please select data",
    成功清除缓存:' clear cache Successfully',
    部署成功:'deploy successfully',
  '模型名称重复，请使用新名称创建模型。':'model name has already exist!',
  '用户名或密码不能为空！':' username or password cannot be empty!',
  "提交成功":"done",
  "提交失败":"failed",
  "已变更":'changed success',
  "已取消变更":'cancel changed',
  "待采明细有采购不能重新生成":'purchase details cannot be re-generated',
  "生成待采明细成功":"successful",
  "生成待采明细失败":'failed',
  "此调取未包含目标模块的字段，请切换到正确的页签":'This fetch does not contain the target module field, please switch to the correct TAB',
  "明细中供应商存在多个，请检查！":"There are multiple suppliers in the details",
  "认领金额不能大于收款金额，请重新填写！":'The claimed amount cannot be greater than the received amount',
  "请选择要赋值的人员":"please select the person name ",
  "请选择模板人员!":"pleease select the teplate name",
  "赋值成功":"done!",
  "赋值失败":'failed'
  },
  // 个性化
  individuation:{
    fieldName:"fieldName",
    visible:"visible",
    total:'total',
    locktopic:"locktopic",
    width:"current width",
    enable:"enable",
    disabled:'disabled'
  },
  //登录
  loginPage: {
    login: "Sign in",
    welCome: 'welcome HXODTS',
    password: "password",
    account: 'account'
  },

  // 消息中心
  messageCenter: {
    addNewMessage: 'Add new message',
    quickRead:'Quick Read',
    remove:'Remove',
    editNewMessage: 'Edit message',
    messageTitle: 'Title',
    modelName:'Model name',
    messageContent: 'Content',
    remark: 'Remark',
    receiveBy: 'Receive by',
    sendBy: 'Send by',
    createTime: 'Create time',
    isRead: 'Has read',
    selected: 'Please select a piece of data',
  },
  placeHolder: {
    expression:'calculation formula expression',
    selectLanguage:'select language',
    forTrackPlaceHolder:'Please fill the order number',
    start:" start",
    end:" end" ,
    to: 'to',
    startDate: 'start date',
    endDate: 'end date',
    selectDate:'select date',

    Financialrecognition:'financial recognition',
    contractNumber:'contract number',

    startTime: "start time",
    endTime: 'end time',
    pleaseFill: "please fill in",
    pleaseSelect: "please select",
    onWeek:"last one week",
    onMonth:'last one month',
    threeMonth:'last three months'
  },
  user: {
    quit: 'quit',
    noticeCenter: "message center",
    preWarning: 'early warning',
    statistical: "report",
    noticeAlert: "notification",
    searchMenu: 'seach here'
  },

  // 首页设置
  Home: {
    ToBeapproved: 'Documents to be approved',// 待审批数据
    realTimeData: 'Realtime Data', // 实时数据
    recents: 'Recents', // 最近访问
    commUsedFun: 'Commonly used function modules',
    messageCenter: 'Message Center',
    more: 'More',
    schedule: 'Schedule',
    scheduleTip: 'No arrangements are available',
    menuCollapse: 'Collapse the menu',
    locations: 'locations',
    organiser: 'organiser',
    participant: 'participant',
    total: 'total',
    people: 'people',
    describe: 'describe',
    type: 'type',
    warn: 'warn',
    delete: 'delete',
    edit: 'edit',
    refreshSchedule: 'refresh Schedule',
    addSchedule: 'add Schedule',
    editSchedule: 'edit Schedule',
    pleaseEnter: 'please Enter',
    pleaseSelect: 'please Select',
    theme: 'theme',
    agendaTopic: 'agenda Topic',
    date: 'date',
    dateRange: 'date Range',
    customerVisit: 'customer Visit',
    visitCustomers: 'visit Customers',
    exhibition: 'exhibition',
    collaborativeWork: 'collaborative Work',
    businessTrip: 'businessTrip',
    conference: 'conference',
    other: 'other',
    startDate: 'start Date',
    endDate: 'end Date',
    to: 'to',
    cancel: 'cancel',
    saveSchedule: 'Save schedule',
    scheduleUpdateSuccess: 'schedule Update Success',
    updateFailure: 'update Failure',
    scheduleAdditionSuccess: 'schedule Addition Success',
    addFailure: 'add Failure',
    scheduleDeletionSuccessful: 'schedule Deletion Successful',
    deletionFailure: 'deletion Failure',
    permanentDeletion: 'This deletes the schedule permanently',
    whetherTOContinue: 'whether TO Continue?',
    tips: 'tips',
    verify: 'verify',
    cancel: 'cancel',
    scheduleStartTime: 'schedule Start Time',
    fiveMinutesAgo: 'five Minutes Ago',
    fifteenMinutesAgo: 'fifteen Minutes Ago',
    anHourAgo: 'an Hour Ago',
    oneDayEarlier: 'one Day Earlier',
  },
    /* 左侧菜单 */
    Menu: {
      messageCenter: 'MessageCenter',
      nodeSettings: 'nodeSettings',
      businessFlowTracking: 'businessFlowTracking',
      SystemAdmin: 'SystemAdmin',
      home: 'home',
      ListSet: 'ListSet',
      FetchSet: 'FetchSet',
      File: 'TransferFile',
      HomeSet: 'HomeSet',
      ReportPermissSet: 'ReportPermissSet',
      dataDict: 'DataDict',
      category: 'Category',
      menuAdmin: 'MenuAdmin',
      userAdmin: 'UserAdmin',
      userOnline: 'UserOnline',
      roleAdmin: 'RoleAdmin',
      deptAdmin: 'DeptAdmin',
      printAdmin: 'PrintAdmin',
      systemLog: 'SystemLog',
      termsTemplete: 'TermsTemplete',
      warningSet: 'WarningSet',
      fieldSet: 'FieldSet',
      dataDictSet: 'DataDictSet',
      fetchFieldSet: 'FetchFieldSet',
      sheetSet: 'SheetSet',
      formSet: 'FormSet',
      codeSet: 'CodeSet',
      editUser: 'EditUser',
      languageSet: 'LanguageSet',
      versionView: 'VersionView',
      persionCenter: 'PersionCenter',
      warnPermissSet: 'WarnPermissSet',
      warning: 'Warning',
      warningFieldSet: 'WarningFieldSet',
      businessModel: 'businessModel',
      systemSet: 'SystemSettings',
      logoSet: 'logoSet',
      loginSet: 'loginBackgroundSet',

      // 流程菜单
      flowMenu: 'FlowMenu',
      flowDefinition: 'FlowDefinition',
      flowConfig: 'FlowConfig',

      flowModel: 'FlowModel',
      modelOnlineDesign: 'ModelOnlineDesign',
      addFlowConfig: 'AddFlowConfig',
      editFlowConfig: 'EditFlowConfig',
      programmeSet: 'program settings',

      // 审批管理
      approvalAdmin: 'ApprovalAdmin',
      peddingApproval: 'PeddingApproval',
      approval: 'Approval',
      Initiated: 'Initiated',
      CCRecord: 'CC record',

      // 订单进度管理
      orderProgressAdmin: 'OrderProgressAdmin',
      orderProgressList: 'OrderProgressList',
      orderNodes: 'OrderNodes',
      orderProgressDetail: 'OrderProgressDetail',
      statisticsReport: 'StatisticalReport',

      // 代码事件配置
      codeEventSet: 'codeEventSet',

    },
  // 列表设置
  listOfSet: {
    add: 'add',
    clearCatch: 'clearCatch',
    loadField: 'load field',
    copyModule: 'copy module',
    search: "search",
    reset: "reset",
    edit: 'edit',
    view: 'view',
    codeGeneration: 'codeGeneration',
    template: 'template',
    confirmClosure: 'confirmClosure ?',
    tabulation: 'tabulation',
    form: 'form',
    codeEvent: 'codeEvent',
    Language: 'Language',
    sheetPage: 'sheetPage',
    attachmentType: 'Attachment type',
    colWidth: 'colWidth',
    moduleName: 'moduleName',
    mainTable: 'mainTable',
    foreignKey: 'foreignKey',
    listSql: 'listSql',
    reminderStoredProcedure: 'Reminder stored procedure',
    attachmentStoredProcedure: 'Attachment stored procedure',
     attachmentStoredProcedureSwitch: 'Attachment stored procedure switch',
    isAuditUpload: 'isAuditUpload',
    reminderCondition: 'Reminder condition',
    isImage: 'isImage',
    imageColumn: 'imageColumn',
    storedProcedure: 'storedProcedure',
    isReadOnly: 'isReadOnly',
    isInlineEditable: 'isInlineEditable',
    isUpdateKeyOnImport: 'isUpdateKeyOnImport',
    isCheckFno: 'noCheckFnoUnique',
    isBatchImport: 'isBatchImport',
    enableOcr: 'enable ocr',
    parentModule: 'parentModule',
    isPage: 'isPage',
    contactSql: 'contactSql',
    listStoredProcedure: 'listStoredProcedure',
    checkStoredProcedure: 'checkStoredProcedure',
    isShowList: 'isShowList',
    tableImgShow: 'tableImgShow',
    formImgShow: 'formImgShow',
    isImport: 'isImport',
    isExport: 'isExport',
    isSendEmail: 'isSendEmail',
    isUploadFile: 'isUploadFile',
    isBatchModify: 'isBatchModify',
    isAboutTypography: 'isAboutTypography',
    isGlobalRetrieval: 'isGlobalRetrieval',
    tableFieldSet: 'tableFieldSet',
    formFieldSet: 'formFieldSet',
    codeEventSet: 'codeEventSet',
    languageSet: 'languageSet',
    sheetSet: 'sheetSet',
    isDbClkJump: 'isDbClkJump',
    isShowSubtotal: 'subtotal',
    showTheApprovalTab: 'showTheApprovalTab',
    passProcName: 'passProcName',
    rejectProcName: 'rejectProcName',
    pageSize: 'pageSize',
    addSuccess: 'Successfully added',
    editSuccss: 'Successfully updated',
    configFormula: 'Formula editor',
    initialization: 'initialization',


    /* 字段设置 */
    fieldShowOrder: 'fieldShowOrder',
    databaseFieldName: 'databaseFieldName',
    showName: 'showName',
    dataType: 'dataType',
    alignType: "alignType",
    queryOperator: "queryOperator",
    isSelect: 'isSelect',
    isLocked: "isLocked",
    isGlobalQuery: 'isGlobalQuery',
    isSum: 'isSum',
    isShow: 'isShow',
    dataDict: 'dataDict',
    datePrecision: "datePrecision",
    language: 'language',
    databaseFields: 'databaseFields',

    //编码设置
    save: 'save',
    year: 'year(2)',
    years: 'year(4)',
    month: 'month',
    date: 'date',
    fixedContent1: 'fixedContent1',
    fixedContent2: 'fixedContent2',
    serialNumber: 'serialNumber',
    loginId: 'loginId',
    serialNoDigit: 'serialNoDigit',
    serialNoUt: 'serialNoUt',
    pattern: 'pattern',
    formField1: 'formField1',
    formField2: 'formField2',
    formField3: 'formField3',
    formField4: 'formField4',
    formField5: 'formField5',
    smallSerialStart: 'smallSerialStart',
    bigSerial: 'big Serial',
    resetSuccess: 'Reset succeeded'
  },
  FormOfSet: {
    uploadDrag:" Drag the file here, or",
    clickUpload:'click here',
     uploadSize:'The file size does not exceed',
    add: 'add',
    fieldOrder: 'fieldOrder',
    name: 'name',
    showName: 'showName',
    defaultValue: 'defaultValue',
    expressionDecimalDigit: 'expressionDecimalDigit',
    dataType: 'dataType',
    editType: 'editType',
    formConfigId: 'formConfigId',
    isMustFill: 'isMustFill',
    isManualEntry: 'isManualEntry',
    approveParam: 'approveParam',
    approveChange: 'approveChangeFile',
    combinedField: 'combinedField',
    majorKey: 'majorKey',
    isShow: 'isShow',
    isReadOnly: 'isReadOnly',
    dataDict: 'dataDict',
    remark: 'remark',
    sheet: 'sheet',
    expression: 'expression',
    clauseTemplete: 'clauseTemplete',
    widthType: 'widthType',
    matchingCondition: 'please select matching criteria',
    noFileSelected: 'No file selected',
    PleaseSelectARuleType: 'Please select a rule type',
    fillingRule: 'Filling Rule',
    promptContent: 'Prompt Content',
    format: 'Format',
    numericType: 'Numeric Type',
    triggerMode: 'Trigger Mode',
  },

  // 配置模块
  configMoudle: {
    ArchivingRemarks: 'Archiving Remarks',
    changeReason: 'reason',
    filesManage: 'Files Manage',
    ocr: 'ocr recognition',
    timedifference:'time difference',

    nodeFinish:'node completion time',

    nodeFlow:'node flow procedure',

    waterKey:'key',

    topLeval:'top level',
    function:"select function",
    operator:'select operator',
    selectfieldName:'select field',
    clear:'clear All',

    fieldType:'field type',

    resultField:'result field',
    formulaEditor:'formula editor',

    fieldDigit:'field digit',
    fieldLength:'field length',

    characteristic:'field characteristic',

    dbname:'database name',
    fieldName:'field name',
    male:'male',
    female:'female',
    normal:'enable',
    diabled:'disable',
    signOrNot:' sign or not',
    catalogue:'catalogue',
    menu:'menu',
    button:'button',
    tableName:'table name',
    subTableName: 'child table name',
    subTable: 'child table ',
    aboutMainTable: 'main table name',
    bulkEdit:'bulkbewerking',

    portDetails:'bills details',
    headSeal: 'letterhead stamp',
    totalAll:'sum',

    noData:'No Data',

    multipleChoice:'multiple choice',

    saveFirst:'Please save first',
    uploadTypeTip:" images only in JPG or PNG format!",
    ForTrackRemark:'attention：The module and the tracking number can not be empty. Please complete the input before submitting',
    uploadSuccess:'successfully upload',
    uploadFail:'successfully upload',
    searchForTrack:'Query order number',
    addFile:'add files',
    updateFile:'change files',

    moveLineNum:'moving number',
    destLineNum:'Destination number',
    selctRowTip:' Please select the data you want to edit',
    selctRowTipDelet:' Please select the data you want to remove',
    noTotalField:'Please select the subtotal field',

    getTemplate:'get template',

    details:'details',

    forModel:'Module',
    forTrack:'Tracking number',
    serialNumber:'number',
    filesLoading:'files loading',
    filesManage:'management of files',

    noConfigTotal:'You have not configured a subtotal',
    noGroup:'please select a grouping condition',

    Financialrecognition:'finance confirm',
    FinancialCancle:' cancel finance confirm',

    noRepeat:'can not be repeated',
    shareSuccess:'shared success',
    confirmRecall:'Make sure to withdraw the current data',
    recallSucces: 'success!',
    CategoryNum:' category number',
    imageUpload:"Multiple image upload",
    selectFillter:'Enter a keyword to filter',
    inventoryNumber:'inventory number',

    confirmDelete: 'make sure to remove?',
    selectYes:"yes",
    selectNo:'no',
    transferOrder: 'Transfer Order',
    saveDefaultTemplate: 'Save default template',
    highSeasCustomers: 'High Seas Customers',
    customerMemorabilia: 'Customer Memorabilia',
    formalCustomers: 'Formal Customers',
    sendEmail: 'sendEmail',
    excelCopy: 'Excel copy',
    claim: 'claim',
    add: 'add',
    edit: 'edit',
    delete: 'delete',
    bulkEdit: 'bulkEdit',
    content: 'Please enter the content',
    selectDate: 'selectDate',
    select: 'select',
    commodityTypeAdmin: 'commodityTypeAdmin',
    typeTitleAdd: 'Commodity type add',
    typeTitleEdit: 'Commodity type edit',
    copyTokey: 'copy to table',
    copyToform: 'copy to form',
    parentType: 'parentType',
    TypeName: 'TypeName',
    clickUpload: 'clickUpload',
    fileView: 'fileView',
    Viewflie: 'Viewflie',
    save: 'save',
    printFormat: 'printFormat',
    cancel: 'cancel',
    print: 'print',
    billsPrint:"billsPrint",
    batchPrinting: 'batchPrinting',
    batchSubmit: 'batchSubmit',
    orderApproveByInfBatch: 'Shanghai Cross-border Export Service 9610 order',
    more: "more",
    share: 'share',
    placeOnFile: 'placeOnFile',
    personnel: 'personnel selection',
    personName: 'person name',
    classChange: 'class change',
    uploadPictures: "upload pictures",
    uploadPicture:"upload picture",

    globalQuery: 'globalQuery',
    modelName: 'modelName',
    search: 'search',
    reset: 'reset',
    img: 'img',
    tip: 'tip',
    tip1: 'Please enter a category name',
    tip2: 'modify successfully ',
    tip3: 'successfully added',
    tip4: 'Please select one',
    tip5: 'Are you sure you want to delete the current category and subcategories',
    tip: 'Tip',
    confirm: 'confirm',
    cancel: 'cancel',
    tip6: 'successfully delete',
    refresh: 'refresh',
    close: 'Close',
    closeLeft: 'Close Left',
    closeRight: 'Close Right',
    closeOther: 'Close others',
    closeAll: 'Close All',
    view: 'view',
    versionView: 'versionView',
    tip7: 'Only Excel format can be uploaded  ',
    tip8: 'You are not the originator of this document',
    tip9: 'The document is under approval or has been approved',
    tip10: 'You did not select a row',
    tip11: 'Do not check approved or pending rows',
    tip12: 'Select a line and then modify it',
    tip13: 'Please select one line before printing',
    tip14: 'Please select report output format!',
    tip15: 'Please select module name!',
    tip16: 'Print success',
    tip17: 'downLoad success',

    approvalHistory: 'Approval history',
    purchaseContract: 'Purchase Contract',
    supplierName:'supplier name',
    fileName:'files names',
    filePath:'files path',
    fileType:'files type',

    compilingAndbrushingLibraries: 'Compiling and brushing libraries',
    moduleName: 'moduleName',
    mainTable: 'mainTable',
    createBy: 'createBy',


    // 详情
    fetch: 'fetch',
    approval: 'approval',
    reject: 'reject',
    approvalOption: 'approvalOption',
    sendEmail: 'sendEmail',
    Examination: 'Examination',
    ExaminationSave: ' save examination',

    AnnextopurchaseContract: 'Annex to purchase Contract',
    Appendixtoexportcontract: 'Appendix to export contract',
    uploadFile: 'uploadFile',
    report: 'report',
    includeFetchSql: 'show exported data',

    includeSqlFinish: 'includeSqlFinish',
    viewLargeImg: 'viewLargeImg',
    save: 'save',
    status: 'status',
    copy: 'copy',
    topcopy: 'top Copy',
    bottomcopy: 'bottom Copy',
    moveRow: 'moveRow',
    update: 'update',
    submit: 'submit',
    recall: 'recall',
    list: 'list',
    copyInvoice: 'copyInvoice',
    tip17: 'Please select the content and click OK',
    tip18: 'The page has been refreshed. Please go to this page again and perform this operation!',
    subTotalSet: 'Subtotal config',
    openSubtotal: 'Open subtotal',
    closeSubtotal: 'Close Subtotal',
    groupCondition: 'Group Condition',
    subtotalField: 'Subtotal Field',
    notSelected: 'Not Selected',
    selected: 'Selected',
    goLeft: 'Left',
    goRight: 'Right',
    noFno: 'Cannot find this contract number, unable to jump',

    // Y-common
    linenum: 'linenum',
    batchDelete: 'batchDelete',
    replaceLineNumber: 'replaceLineNumber',
    tip19: 'The line number you entered is invalid',
    tip20: 'In approval state...',
    tip21: 'Please select the data to delete',
    tip22: 'Only one line can be selected for newline',
    tip23: 'Please select the data you want to share',
    tip24: 'Please select the data you want to archive or unarchive',
    tip25: 'Please select the person you want to share',
    tip26: 'Whether to cancel the archive？',
    tip27: "Canceling archive succeeded",
    tip28: "Archiving success",
    tipQuit: 'Make sure to quit?',
    sureToSave: 'Please click the confirm button after checking that the data is saved!',
    cancelFilter: 'cancelFilter',


    SalesContract: 'Sales Contract ',
    PurchaseContract: 'Purchase contract',
    alteration: 'alteration',
    cancelAlteration: 'cancelAlteration'

  },

  // 列表设置-----语言设置
  LanguageSet: {
    contentRequire:"language can not be empty",
    contentRequire: "content can not be empty",
    promptLanguage: 'Prompt Language',
    addPromptLanguage: 'Add Prompt Language',
    add: "add",
    language: 'language',
    content: 'content',
    operation: 'operation',
    simplifiedChinese: "simplifiedChinese",
    confirm: "confirm",
    cancel: "cancel"
  },

  // 列表设置--- sheet页设置
  SheetSetting: {
    name: 'name',
    AccordingToTheOrder: 'AccordingToTheOrder',
    add: 'add'
  },

  // 调取设置
  FetchSet: {
    sequence: 'sequence',
    add: 'add',
    name: 'name',
    targetModuleId: 'targetModuleId',
    parentModuleId: 'parentModuleId',
    targetField: 'targetField',
    isPaged: 'isPaged',
    fetchSql: 'fetchSql',
    isShowImage: 'isShowImage',
    showColumns: 'showColumns',
    isRetrieval: 'isRetrieval',
    containsCalledSQL: 'containsCalledSQL',
    edit: 'edit',
    delete: 'delete',
    languageSetting: 'languageSetting',
    tableFiledSetting: 'tableFiledSetting',
    copySetting: 'copySetting',
    fetchWarinning: 'Please fill in the retrieval statement',
    cancel: 'cancel',
    confirm: 'confirm',
    over: 'override',
  },

  // 调取设置 ---- 调取字段设置
  FetchKeySet: {
    add: 'add',
    fieldShowOrder: 'fieldShowOrder',
    databaseFieldName: 'databaseFieldName',
    showName: 'showName',
    dataType: 'dataType',
    alignType: "alignType",
    isSelect: 'isSelect',
    queryOperator: "queryOperator",
    isSortable: 'isSortable',
    isFetched: "isFetched",
    isLocked: "isLocked",
    targetField: "targetField",
    isShow: "isShow",
    datePrecision: "datePrecision",
  },


  // 首页设置
  homeSet: {
    homeSet: "homeSet",
    roleNamePlaceHolder: 'roleNamePlaceHolder',
    warningSet: 'warningSet',
    reportSet: 'reportSet',
    earlyWarning: 'earlyWarning',
    title: 'title',
    router: 'router',
    sql: 'sql',
    languageSetting: 'languageSetting',
    save: 'save',
    select: 'Please select',
    inputPlaceHolder: 'inputPlaceHolder',
    report: 'report',
    save: 'save',
    add: 'add',
    edit: 'edit',
    submitTip: 'The submitted data cannot be empty',
    saveTip: 'Save Success',
    completeTip: 'Please improve the data and save it before setting the language',
    saveFailed: 'Save Failed',
    qrSetting: 'QR code setting',
    qrUpload: 'App QR code upload',
    qrEdit: 'QR code information editing',
    qrPlaceholder: 'Please enter the information to edit',
    qrTips: 'Please upload the picture first',
    basicInfor: "basic information",
    fontConfig: "Fonts",
    passWordConfig: 'password',
    languageConfig: "language",
    fontSize: "Font size Settings",
    fontFamily: 'Font familly Settings',
    oldPassword: 'old password',
    newPassword: 'new password',
    languageSet: 'language Settings',

    defaultFont: 'default',
    smallFont: 'small',
    largeFont: 'large',
    song: 'song',
    kai: "DFKai-SB",
    yuan: 'yuan',
    shijian: 'Air',
    logoSetting: 'LogoSetting',
    companySetting: 'companyName',
    loginBackgroundSetting: 'loginBackgroundSetting',
  },

  // 报表权限设置
  ReportSet: {
    jimuReportPermissionSetting: 'jimuReportPermissionSetting',
    roleNamePlaceHolder: 'Enter a role name',
    save: 'save',
    code: 'code',
    reportName: 'reportName',
    createTime: 'createTime',
    warningTip: 'Please select at least one option',
    saveTip: 'Save Success',
    add: 'add',
    edit: 'edit',
  },

  // 字典设置
  DictSet: {
    searchButton: 'search',
    resetButton: 'reset',
    add: 'add',
    edit: 'edit',
    delete: 'delete',
    dictName: 'dictName',
    isForbidden: 'isForbidden',
    enabled: 'enabled',
    disAbled:"disabled",

    remark: 'remark',
    dataItemSetting: 'dataItemSetting',
    name: 'name',
    alias: 'alias',
    sortOrder: 'sortOrder',
    desc: 'desc',
    dataPermission: 'dataPermission',
  },

  // 菜单管理
  menuSet: {
    permisVies:"permissions",

    menuName: 'menuName',
    search: 'search',
    reset: 'reset',
    add: 'add',
    edit: 'edit',
    delete: 'delete',
    icon: 'icon',
    type: 'type',
    orderNum: 'orderNum',
    permsCode: 'permsCode',
    remark: 'remark',
    routingPath: 'routingPath',
    menuStatus: 'menuStatus',
    addMenu: 'addMenu',
    menuType: 'menuType',
    menuIcon: 'menuIcon',
    menuIconColor: 'menuIconColor(multicolor)',
    menuVisable: 'menuVisible',
    online: 'is Online',
    componentPath: 'component Path',
    menuOrder: 'menuOrder',
    parentCatalogue: 'parentCatalogue',
    associatedModule: 'associatedModule',
    buttonName: 'buttonName',
    language: 'language',
    deleteTip: 'Confirm deletion?',
    tip: 'Tip',
    confirm: 'confirm',
    cancel: 'cancel',
    firstSelectDelete: 'Please select before deleting',
    deleteSuccess: 'delete Success',
    action: 'operation'
  },

  // 用户管理
  userAdmin: {
    deptPlace: 'Please enter a department name',
    userName: 'userName',
    password: 'password',
    loginAccount: 'loginAccount',
    phoneNumber: 'phoneNumber',
    status: 'status',
    createTime: 'createTime',
    search: 'search',
    reset: 'reset',
    add: 'add',
    passOn: 'passOn',
    passOnPerson: 'target personnel',
    passOnMoudle:'transfer module',

    deptName: 'deptName',
    nickName: 'nickName',
    englishName: 'englishName',
    email: 'email',
    roleName: 'roleName',
    sex: 'sex',
    postId: 'postId',
    avatar: 'avatar',
    deptId: 'deptId',
    passoword: 'passoword',
    remark: 'remark',
    dept: 'dept',
    edit: 'edit',
    delete: 'delete',
    tip1: 'Select one to modify',
    loadingtip: 'Loading, please wait...',
    tip2: 'Select an item to delete',
    tip3: 'Confirm deletion?',
    tip: 'Tip',
    confirm: 'confirm',
    cancel: 'cancel',
    deleteSuccess: 'deleteSuccess!',
    editSuccess: 'editSuccess!',
    noEmpty: ' can not be empty',
    limitOfAuthority: 'limit of authority',
    synchronousAssignmentGroup: 'synchronous assignment group',
  },

  // 用户管理 --- 编辑用户
  editUserAdmin: {
    save: 'save',
    sync: 'sync',
    add: 'add',
    userInfo: 'userInfo',
    nickName: 'nickName',
    englishName: 'englishName',
    password: 'password',
    phoneNumber: 'phoneNumber',
    remark: 'remark',
    loginAccount: 'loginAccount',
    userEmail: 'userEmail',
    postId: 'postId',
    dept: 'dept',
    roleName: 'role',
    superiorLeaders: 'superiorLeaders',
    sex: 'sex',
    status: 'status',
    emailConfig: 'emailConfig',
    dataPermission: 'dataPermission',
    modelName: 'modelName',
    groupName: 'groupName',
    groupCode: 'groupCode',
    edit: 'edit',
    delete: 'delete',
    loadingtip: 'Loading, please wait...',
    saveSuccess: 'saveSuccess',
    emailUserName: 'addresserName',
    userEmail: 'addresserEmail',
    emailPassword: 'emailPassword',
    smtpHost: 'SMTPAddress',
    smtpPort: 'SMTPPort',
    signature: 'signature',
    ownPhone: 'Private mobile number',
    qq: 'QQ',
    weChat: 'WeChat',
    platformName: 'Platform Name',
    idcard: 'idcard',
    isEmailManage: 'Whether an email administrator',
    noPicture: 'no photo',

  },



  // 在线用户

  userOnline: {
    userName: 'userName',
    name: 'name',
    search: 'search',
    reset: 'reset',
    kickOut: 'kickOut',
    email: 'email',
    phone: 'phone',
    sex: 'sex',
    loginConputerIp: 'loginConputerIp',
    loginTime: 'loginTime',
    nowTime: 'nowTime',
    status: 'status',
    remark: 'remark',
    tip1: 'Confirm to kick out the user?',
    tip: 'Tip',
    confirm: 'confirm',
    cancel: 'cancel',
    tip2: 'Please select before kicking out!',
    tip3: 'User kicked out'
  },


  // 角色管理

  roleAdmin: {
    addRole:'role add',
    cancleRole:"role cancle",
    tip1: 'Are you sure you want to delete the selected role?',
    menuAllot: 'menuAllot',
    roleName: 'roleName',
    status: 'status',
    search: 'search',
    reset: 'reset',
    add: 'add',
    save: 'save',
    showSort: 'showSort',
    roleStatus: 'roleStatus',
    permissionChar: 'permissionChar',
    permissionScope: 'permissionScope',
    dataScope: 'dataScope',
    remark: 'remark',
    edit: 'edit',
    delete: 'delete',
    tip2: 'noEmpty!',
    tip3: 'Please select before deleting',
    tip4: 'Please select the menu to modify the assignment',
    tip5: 'saveSuccess'
  },


  // 部门管理
  deptAdmin: {
    deptName: 'deptName',
    status: 'status',
    search: 'search',
    reset: 'reset',
    remark: 'remark',
    add: 'add',
    deptCode: 'deptCode',
    departmentHead: 'departmentHead',
    contactWay: 'contactWay(phone)',
    showSort: 'showSort',
    createTime: 'createTime',
    addDept: 'addDept',
    superiorDepartment: 'superiorDepartment',
    edit: 'edit',
    delete: 'delete',
    tip1: 'Are you sure to delete the checked departments?',
    tip: 'Tip',
    confirm: 'confirm',
    cancel: 'cancel',
    tip2: 'Please select before deleting!',
    tip3: 'deleteSuccess'
  },

  //打印管理
  printAdmin: {
    add: 'add',
    modelNumber: 'moduleNumber',
    modelCode: 'moduleCode',
    modelId: 'moduleId',
    modelName: 'moduleName',
    mainTableName: 'mainTableName',
    reportName: 'reportName',
    idField: 'idField',
    remark: 'remark',
    edit: 'edit',
    delete: 'delete',
    tip1: 'Are you sure to delete the checked modules?',
    tip: 'Tip',
    confirm: 'confirm',
    cancel: 'cancel',
    tip2: 'Please select before deleting',
    tip3: 'deleteSuccess',
    total: 'NumberOfDownload',
    printer: 'Report Designer',
    closeConfirm: 'Was it saved before closing?'
  },

  // 系统日志
    Systemlog: {
    fno: 'Number',
    tip: 'Tip',
    requestParams: 'RequestParams',
    returnParams: 'ReturnParams',
    module: 'Module',
    status: 'Status',
    message: 'Message',
    remark: 'Remark',
    createByName: 'Username',
    createTime: 'Time',
    execTime: 'Seconds',
    requestMethodName: 'RequestMethodName',
    requestIp: 'RequestIp',
    requestWay: 'RequestWay',
    bussinessType: 'BussinessType',
    cancel: 'Cancel',
    confirm: 'Confirm',
    search: 'Search',
    reset: 'Reset',
    add: 'Add',
    delete: 'Delete',
    tip1: 'Are you sure to delete the checked parameters?',
    tip2: 'Please select before deleting',
    tip3: 'DeleteSuccess'
  },

  // 模板类型
  termsTemplete: {
    add: 'add',
    templeteName: 'templeteName',
    templeteContent: 'templeteContent',
    content: 'content',
    templeteType: 'templeteType',
    createBy: 'createBy',
    createTime: 'createTime',
    updateBy: 'updateBy',
    updateTime: 'updateTime',
    selectDate: 'selectDate',
    cancel: 'cancel',
    confirm: 'confirm',
    search: 'search',
    reset: 'reset',
    delete: 'delete',
  },

  //预警设置
  warning: {
    content: 'content',
    select: 'select',
    warningTitle: 'warningTitle',
    isPage: 'isPage',
    warningSql: 'warningSql',
    CustomMenuName: 'CustomMenuName',
    remark: 'remark',
    showOrder: 'showOrder',
    isShow: 'isShow',
    cancel: 'cancel',
    confirm: 'confirm',
    add: 'add',
    edit: 'edit',
    batchDeletes: 'batchDeletes',
    delete: 'delete',
    languageSet: 'languageSet',
    warningFieldSet: 'warningFieldSet',
    tip1: 'Please select the data to delete',
    tip2: 'addSuccess',
    warningName: 'Warning name',
    emptyContent: 'Click the report name on the left to select the report',
  },
  // 预警设置---预警字段设置
  warnFieldSet: {
    databaseName: 'databaseName',
    search: 'search',
    fieldShowOrder: 'fieldShowOrder',
    datebaseField: 'datebaseField',
    showName: 'showName',
    dataType: 'dataType',
    select: 'select',
    alignType: 'alignType',
    isSelect: 'isSelect',
    QueryOperator: 'QueryOperator',
    isLock: 'isLock',
    datePrecision: 'datePrecision',
    isShow: 'isShow',
    cancel: 'cancel',
    confirm: 'confirm',
    add: 'add',
    edit: 'edit',
    languageSet: 'languageSet',
    tip1: 'Please select the data to delete',
    tip2: 'add Success',
  },


  // 流程模型
  flowModel: {
    name: 'name',
    search: 'search',
    reset: 'reset',
    add: 'add',
    flowKey: 'flowKey',
    version: 'version',
    createTime: 'createTime',
    updateTime: 'updateTime',
    metadata: 'metadata',
    edit: 'edit',
    delete: 'delete',
    upload: 'upload',
    download: 'download',
    downLoad: 'downLoad',
    addFlowModel: 'addFlowModel',
    category: 'category',
    desc: 'desc',
  },

  // 流程定义
  flowDefinition: {
    operation: 'operation',
    moduleId: 'moduleId',
    moduleName: 'moduleName',
    programmeId: 'programmeId',
    programmeName: 'programmeName',
    processDefinitionKey: 'processDefinitionKey',
    remark: 'remark',
    tip4: 'Are you sure to delete the checked modules?',
    tip5: 'Please select before deleting',
    tip6: 'saveSuccess',
    save: 'save',
    active: 'active',
    hangUp: 'hangUp',
    transferModel: 'transferModel',
    delete: 'delete',
    upload: 'upload',
    category: 'category',
    select: 'select',
    selectFile: 'selectFile',
    clickUpload: 'clickUpload',
    cancel: 'cancel',
    confirm: 'confirm',
    flowChart: 'flowChart',
    flowKey: 'flowKey',
    flowName: 'flowName',
    search: 'search',
    reset: 'reset',
    flowId: 'flowId',
    version: 'version',
    flowDesc: 'flowDesc',
    uploadTime: 'uploadTime',
    flowDefinition: 'flowDefinition',
    deploymentProcessDefinition: 'deploymentProcessDefinition',
    flowDefinitionStatus: 'flowDefinitionStatus',
    edit: 'edit',
    delete: 'delete',
    actived: 'actived',
    tip1: 'Are you sure you want to delete this process?',
    tip: 'Tip',
    confirm: 'confirm',
    cancel: 'cancel',
    tip2: 'delete Success',
    tip3: 'Please select category and submit again',
    selectModule:'select module name',
    selectProgramme:'select programme name',
    add:'add'
  },


  // 审批方案
  programmeSet: {
    name: 'name',
    search: 'search',
    reset: 'reset',
    add: 'add',
    nodeSetTip:'Please select the approval node',

    groups:'Approver Groups',
    Appoint:'Appoint the approver',
    jointTrial :"Is jointTrial ",

    nodeSet:'Approval node setting',

    programmeSetAdd:'add  programme',
    programmeSetEdit: 'edit programme',
    programmeSetName: 'programme name',
    programmeSetCode: 'programme number',
    approvalNode: 'approval node',
    version: 'version',
    createTime: 'create time',
    updateTime: 'update time',
    metadata: 'meta data',
    edit: 'edit',
    delete: 'delete',
    upload: 'deploy',
    download: 'export',
    addFlowModel: 'add flow model',
    category: 'classify',
    desc: 'describe',
  },


  // 审批
  Approval: {
    auditor:'auditor',

    backTo: 'back to node',
    tipNode: 'It will be returned to the submitter by default if you do not select ',
    tipRed: '',
    operation: 'operation',
    agree: 'agree',
    reject: 'reject',
    approveParam: 'approveParam',
    history: 'history',
    schedule: 'schedule',
    view: 'view',
    confirm: 'confirm',
    cancel: 'cancel',
    approvalOption: 'approvalOption',
    approvalProcess: 'approvalProcess',
    approvalHistory: 'approvalHistory',
    scheduleChart: 'scheduleChart',
    initiator: 'initiator',
    moduleName: 'moduleName',
    search: 'search',
    reset: 'reset',
    refresh: 'refresh',
    approvalAgree: 'approvalAgree',
    approvalReject: 'approvalRejct',
    forwarded: 'forwarded',
    approvalTime: 'approvalTime',
    // assignee: 'assignee',
    approvalParam: 'approvalParam',
    taskName: 'taskName',
    assignee: 'Approver',
    startTime: 'startTime',
    endTime: 'endTime',
    durationTime: 'durationTime',
    refreshSuccess: 'refreshSuccess',
    refressFail: 'refressFail',
    forwardSuccess: 'Success',
    forwardFail: 'Fail',
    tip1: 'Please select this box before proceeding!',
    tip2: 'Please check and reject the operation!',
    viewInvoices: 'viewInvoices',
    print: 'print',
    approvalStatus: 'approvalStatus',
    tip44: 'Please fill in the approval opinion',
    initiationDate: 'Initiation date',
    save: 'save',
    fno: 'business number',
    read: 'read',
    readSuccess: 'read Success',
  },

  // 订单进度管理
  Order: {
    orderProgressTable: 'orderProgressTable',
    progress: 'progress',
    operation: 'operation',
    viewDetail: 'viewDetail',
    orderProgressChart: 'orderProgressChart',
    contractNumber: 'contractNumber',
    contractDate: 'contractDate',
    customerName: 'customerName',
    search: 'search',
    reset: 'reset',
    refresh: 'refresh',
    deliveryDate: 'deliveryDate',
    destinationPort: 'destinationPort',
    shipmentPort: 'shipmentPort',
    createBy: 'createBy',
    progress: 'progress',


    addNode: 'addNode',
    confirmNode: 'confirmNode',
    linkName: 'linkName',
    computeMode: 'computeMode',
    basisNode: 'basisNode',
    Days: 'Days',
    createDate: 'createDate',
    chargePersion: 'chargePersion',
    status: 'status',
    edit: 'edit',
    delete: 'delete',
    selectNode: 'selectNode',
    confirm: 'confirm',
    cancel: 'cancel',
    sendSuccess: 'sendSuccess',


    addNodes: 'addNodes',
    nodeName: 'nodeName',
    nodeEndCondition: 'nodeEndCondition',
    nodeEndConditionSql: 'nodeEndConditionSql',
    nodesName: 'nodesName',
    createByName: 'createByName',
    createTime: 'createTime',
    tip1: 'Are you sure you want to delete this node?',
    tip: 'Tip',
    saveSuccess: 'saveSuccess',
  },




  // 嵌套BI系统
  Bisystem: {
    BiName: "Statistics"
  },
  StatisticalManagement: {
    StatisticalManagement: "Statistical Management",
  },
  // email
  Emails: {
    edit: 'edit',
    sign: 'signature',
    folders: 'folders',

    eName: 'EmailSystem',
    write: 'WriteEmail',
    contact: 'Contacts',
    inbox: 'Inbox',
    outbox: 'Outbox',
    drafts: 'Drafts',
    trash: 'Spam',
    folders: 'MyFolders',
    searchFolder: "search folders",
    label: 'Email Label',
    settings: 'Email Settings',
    please: 'Please Login',
    login: 'Login',
    loginsuccess: 'Login Success',
    loginfailed: 'Login Failed',
    account: 'Account',
    selectAccount: 'Account',
    signContent: 'content',
    password: 'Password',
    notnull: 'Account or password cannot be blank',
    cancel: 'Cancel',
    go: 'Go on',
    register: 'Register',
    regSuccess: 'Register Success',
    khname: 'Unit Name',
    copy: 'Copy Send',
    secret: 'Secret Send',
    addcopy: 'Add Copy Send',
    addsecret: 'Add Secret Send',
    delcopy: 'Delete Copy Send',
    delsecret: 'Delete Secret Send',
    addressee: 'Addressee',
    copyName: 'CC',
    linkTips: 'Liaison not found, please to add liaison at Contacts',
    theme: 'Theme',
    upload: 'Upload attachments',
    clearFiles: 'Clear list',
    numsTips: 'Number of attachments currently selected: ',
    uploadTips: 'Total list size: ',
    readReceipt: 'Read Receipt',
    Sender: 'Sender',
    pickSender: 'Select a sender',
    send: 'Send',
    save: 'Save',
    reset: 'Reset',
    taskAddBut: 'Add',
    entrustAddBut: 'Add',
    taskRemoveBut: 'Remove',
    entrustRemoveBut: 'Remove',
    addresseeEmpty: 'Addressee cannot be empty',
    themeEmpty: 'Theme cannot be empty',
    senderEmpty: 'Sender cannot be empty',
    senderNull: 'No sender yet, please go to Email Settings to add',
    textEmpty: 'Sending content cannot be empty',
    sendSuccess: 'Send successful',
    sendFail: 'Send failed',
    saveSuccess: 'Save successful',
    saveFail: 'Save failed',
    refresh: 'Refresh',
    themeKeyword: "Theme's keyword",
    contentKeyword: "Content's keyword",
    senderKeyword: 'Select sender',
    getAll: 'select all',
    clearAll: 'clear all',
    oneByone: 'Send a group message 1 by 1',
    generatedBy: "generated by Artificial intelligence",
    languageSet: 'language',
    transLate: 'transLate',
    promotional: 'promotional letter',
    exampleContent: 'example:Please generate a foreign trade development letter for retail industry customers for me. My name is Zhang SAN, from xxx company. Our main products and services are foreign trade software, and the target market is Southeast Asia.',
    readStatus: 'Reading status',
    addMails: "insert",
    all: 'All',
    unread: 'Unread',
    read: 'Read',
    removed:"removed",
    receive: 'Receive',
    delete: 'Delete',
    emailNums: 'Total email',
    emailUnread: 'Unread email',
    receiving: 'Receiving...',
    receiveFail: 'Receiving Failed',
    receiveSuccess: 'Receiving Success',
    emailDetails: 'Click to view email details',
    delTips: 'Please select before deleting',
    delSuccess: 'Deleted successfully',
    delFail: 'Deleted failed',
    contactsList: 'Contacts List',
    contactsManage: 'Contacts Manage',
    categoryManage: 'Category Manage',
    categoryName: 'Category Name',
    customerName: 'Customer Name',
    name: 'Name',
    customerCode: 'Customer Code',
    email: 'Email',
    operation: 'Operation',
    categoryParent: 'Category Parent',
    phone: 'Phone',
    reply: 'Reply',
    replyAll: 'Reply All',
    date: 'Date',
    saving: 'Save',
    pickCategory: 'Choose category',
    edit: 'Edit',
    cateTips: 'Please select one correctly',
    writeCategoryName: 'Fill in the category name',
    nameMailTips: 'Please complete your name and email address',
    recoverySuccess: 'Recovery successful',
    recoveryFail: 'Recovery Fail',
    newFolder: 'New folder',
    editFolder: 'edit folder',

    addFolderTips: 'Please enter a folder name',
    folderName: ' folder name',

    addSuccess: 'Successfully added',
    addFail: 'Failed to add',
    emailSetting: 'Mailbox settings',
    signSetting: 'Signature settings',
    folderSetting: 'Folder settings',
    displayName: 'Display Name',
    senderName: 'Sender Name',
    copyName: 'copyName',
    emailAddress: 'E-mail address',
    addSetting: 'add',
    sendName: 'sender name',
    required: 'please fill in the ',
    requiredSelect: 'please select the ',
    selectMoveWarning: 'Please select the message you want to move',
    moveSuccess: "success",
    maveFailed: 'failed',
    sendingServer: 'Sending server',
    Authorization: 'Password',
    sendserverType: "Server type(receive)",
    serverAddress: "Server address",
    sendserverAddress: "Server address(send)",
    isDefault: 'isDefault',
    enable: 'enable',
    port: 'Port',
    sendTime: 'Sending time',

    originalMail: 'Original mail',
    receiveAll: "Receive all accounts'email",
    receiveMailPick: 'Please select the account to be charged',
    receiveMailTime: 'Please select the time period to be charged',
    receiveEmail: 'Mail receiving',
    emailNums: 'Number of emails',
    relatedModules: 'Related modules',
    moduleName: 'moduleName',
    fno: 'fno',
    selectReportFile: 'selectReportFile',
    uploaded: 'Uploaded attachments',
    uploadSuccess: 'Upload successful',
    uploadFailed: 'Upload failed',
    selectModelName: 'Please select module name',
    selectPrintFormat: 'Please select a print format',
    readTime: 'Read Time',
    readAddress: 'Address',
    readCount: 'Read Count',
    markAllAsRead: 'Mark all as read"',
    markSelectedAsRead: 'Mark selected as read',
    markAllAsReadTip: 'Are you sure you want to mark all emails as read',
    markSelectedAsReadtip: 'Are you sure you want to mark the selected emails as read',
    markedSuccess: 'Marked successfully',
    markedFail: 'Marking failed',
    moveto: 'Move to',
    emailForward: 'Forward',
    emailTemplate: 'Template',
    addTemplate: 'add Template',
    EditTemplate: 'edit Template',

    restore: 'Are you sure you want to recover this email',
    emailSet: 'MailboxConfiguration',
    noAccount: 'You have not configured an email account',
    goToSet: ' go to settings',
    eMarketingName:'Email marketing',
    eMarketingTemplate: "Template",
    eMarketingTask: "Task",
    eMarketingEntrust: 'Entrust marketing',
    eMarketingStatistics: 'Statistics',
  },
    // 补充tips
    addTips: {
      approve:'approving',
      reject:'reject',
      pass:'passed',
      noUse:'This module is disabled',
      hasPigeonhole:'filed',
      noPigeonhole:'Not filed',
      all:'all',
      cancel:'cancel',
      confirm:'confirm',
      noSupportpreview:'the file does not support preview',
      isAssign:"assign",
      programmeNameRequire:'please fill programme name',
      programmeCodeRequire:"please fill programme code",
      addPerson:'Please select personnel',
      number:'number',
      groupEmpty:"group name cannot be empty",
      approveEmpty:'Please add an approval node',
      nodeEmpty:"node data cannot be empty",

      tempNameRequire:'template name must be require',
      refreshDatabase:'loading',
      tableNameRequire:'tablename must be require',

      nowusebbs:'child table names cannot be repeated',

      tableNameNorepeat:"Table names must be unique",

      moduleNameNorepeat:'the template name must be unique',
      done:'done!',
      doneFailed:'failed!',
      successZhengshi:' converted into a full customer success',
      selectZhengshi:'Please select the client ',
      successGonghai:'converted to high seas customer success',
      selectGonghai:'Please select the client ',
      selectClassIs:'the choice is',
      ifContinue:'Are you sure to continue?',
      selectGiveData:'Please select the data you want to transfer',

      addTopClass:"Please select a category first",

      cantclaimed:'Select the lowest level of the tree structure',

      treeBelow:'Select the lowest level of the tree structure',

      orderNo:"purchase order does not exist",
      goodCanNotDelete:'cannot remove',

      addoccupy:'Please select the details you want to occupy',
      onlyOneoccupy:'Only one detail occupation can be selected at a time',

      onlyOneTop:'Only one top-level primary table can be selected',

      comfirmDelet:"make sure to remove?",
      selectRow:"please select the line you want to move",
      onlyOneRowMove:"Only one row can be selected to move",
      noEffectRow:'the destination line number is invalid',
      noMaxLine:'exceed the maximum line number',
      fetchNoMove:'remove failed , the detail data has been called ',
      checkError:'Check  exception',
      nodeNoGood:'There is no product ',
      languageNoRepeat:' language has already exsit ',
      tableNoData: 'Please set them and try again!',
      subassembly: 'subassembly:'

    },
  GlobalConfig: {
    duplicationCheck: 'Duplication check',
    CustomerSwitch: 'Customer switch',
    SupplierSwitch: 'Supplier switch',
    GoodsSwitch: 'Goods switch',
    FeedbackConfiguration: 'Feedback configuration',
    projectName: 'Project Name',
    projectContact: 'Project Contact Number',
    version: 'Version',
    systemCallbackAddress: 'System Callback Address',
    wincareAddress: 'Wincare Address',
    projectNamePlace: 'Please fill in the project name',
    projectContactPlace: 'Please fill in the project contract number',
    wincareAddressPlace: 'Please fill in the wincare address'
  },
    // 表单配置
    formSet:{
      languageSet:"language",
      stretch:'stretch',
      tile:'tile',
      half:'stretch half',
      third:'Take up a third',
      leftJustify: 'jusifycontent-left',
      rightJustify: 'jusifycontent-right',
      center: "jusifycontent-cener",
      equal: 'equal',
      DateRange: 'DateRange',
      less: 'less',
      lessOrequal: 'lessOrequal',
      greater: 'greater',
      greatorequal: "great or equal",
      like: 'like',
      left: 'left',
      right: 'right',
      between: 'between',
      database:'dataBase',
      expression:'custom expression',
      year:'year',
      month:'month',
      day:'day',
      hour:'hour',
      minute:'minute',
      second:'second',
      input:'input box' ,
      dateRange :	 'dateRange' ,
     dateInput:'date input' ,
     selectOption:'select option',
     switch:'switch' ,
     textarea:'text area' ,
     numberInput:'number input' ,
     richText:'rich text' ,
     checkBox:'check box' ,
      people: 'people' ,
       citySelect:'city select' ,
       selectInput:'select input',
       permiAll: 'all',
       permiCustom: 'user define',
       department: 'department',
       deptBelow: "department below",
       selfOnly:'self only'
      },



    // 版本
    version: {
    record:'Update record',
    log: 'Edit record',
    times:"Update times",
    updateDate:"Update date",
    updatePerson:"Update by",
    mainTableData:'Main datas',
    detailsOldData:'Detail raw data',
    detailsData:'Detail update data',
    oldData:"Raw data",
    newData:"Update data",
    moduleName:"Module name",
    post:"Post",
    put:"Put",
    remove:"Remove",
    get:"Get",
    success:"Successful",
    fail:"Fail",
    business:"Business data",
    other:"Other Data",
  },


    //登录
    loginPage: {
      login: "Sign in",
      welCome: 'welcome HXODTS',
      password: "password",
      account: 'account'
    },

    // 消息中心
    messageCenter: {
    addNewMessage: 'Add new message',
    quickRead:'Quick Read',
    remove:'Remove',
    editNewMessage: 'Edit message',
    messageTitle: 'Title',
    modelName:'Model name',
    messageContent: 'Content',
    remark: 'Remark',
    receiveBy: 'Receive by',
    sendBy: 'Send by',
    createTime: 'Create time',
    isRead: 'Has read',
    selected: 'Please select a piece of data',
  },
    placeHolder: {
      expression:'calculation formula expression',
      selectLanguage:'select language',
      forTrackPlaceHolder:'Please fill the order number',
      start:" start",
      end:" end" ,
      to: 'to',
      startDate: 'start date',
      endDate: 'end date',
      selectDate:'select date',

      Financialrecognition:'financial recognition',
      contractNumber:'contract number',

      startTime: "start time",
      endTime: 'end time',
      pleaseFill: "please fill in",
      pleaseSelect: "please select",
      onWeek:"last one week",
      onMonth:'last one month',
      threeMonth:'last three months',

    },
    user: {
      quit: 'quit',
      noticeCenter: "message center",
      preWarning: 'early warning',
      statistical: "report",
      noticeAlert: "notification",
      searchMenu: 'seach here'
    },

    // 首页设置
    Home: {
    ToBeapproved: 'Documents to be approved',// 待审批数据
    realTimeData: 'Realtime Data', // 实时数据
    recents: 'Recents', // 最近访问
    commUsedFun: 'Commonly used function modules',
    messageCenter: 'Message Center',
    more: 'More',
    schedule: 'Schedule',
    scheduleTip: 'No arrangements are available',
    menuCollapse: 'Collapse the menu',
    locations: 'locations',
    organiser: 'organiser',
    participant: 'participant',
    total: 'total',
    people: 'people',
    describe: 'describe',
    type: 'type',
    warn: 'warn',
    delete: 'delete',
    edit: 'edit',
    refreshSchedule: 'refresh Schedule',
    addSchedule: 'add Schedule',
    editSchedule: 'edit Schedule',
    pleaseEnter: 'please Enter',
    pleaseSelect: 'please Select',
    theme: 'theme',
    agendaTopic: 'agenda Topic',
    date: 'date',
    dateRange: 'date Range',
    customerVisit: 'customer Visit',
    visitCustomers: 'visit Customers',
    exhibition: 'exhibition',
    collaborativeWork: 'collaborative Work',
    businessTrip: 'businessTrip',
    conference: 'conference',
    other: 'other',
    startDate: 'start Date',
    endDate: 'end Date',
    to: 'to',
    cancel: 'cancel',
    saveSchedule: 'Save schedule',
    scheduleUpdateSuccess: 'schedule Update Success',
    updateFailure: 'update Failure',
    scheduleAdditionSuccess: 'schedule Addition Success',
    addFailure: 'add Failure',
    scheduleDeletionSuccessful: 'schedule Deletion Successful',
    deletionFailure: 'deletion Failure',
    permanentDeletion: 'This deletes the schedule permanently',
    whetherTOContinue: 'whether TO Continue?',
    tips: 'tips',
    verify: 'verify',
    cancel: 'cancel',
    scheduleStartTime: 'schedule Start Time',
    fiveMinutesAgo: 'five Minutes Ago',
    fifteenMinutesAgo: 'fifteen Minutes Ago',
    anHourAgo: 'an Hour Ago',
    oneDayEarlier: 'one Day Earlier',
    },
    // 列表设置
    listOfSet: {
      ponoFieldExist: 'The pono field does not exist',
      attachmentManagement: 'Import accessory management',
      add: 'add',
      clearCatch: 'clearCatch',
      loadField: 'load field',
      copyModule: 'copy module',
      search: "search",
      reset: "reset",
      edit: 'edit',
      view: 'view',
      codeGeneration: 'codeGeneration',
      template: 'template',
      confirmClosure: 'confirmClosure ?',
      tabulation: 'tabulation',
      form: 'form',
      codeEvent: 'codeEvent',
      Language: 'Language',
      sheetPage: 'sheetPage',
      attachmentType: 'Attachment type',
      colWidth: 'colWidth',
      moduleName: 'moduleName',
      mainTable: 'mainTable',
      foreignKey: 'foreignKey',
      listSql: 'listSql',
      reminderStoredProcedure: 'Reminder stored procedure',
      attachmentStoredProcedure: 'Attachment stored procedure',
      attachmentStoredProcedureSwitch: 'Attachment stored procedure switch',
      isAuditUpload: 'isAuditUpload',
      reminderCondition: 'Reminder condition',
      isImage: 'isImage',
      imageColumn: 'imageColumn',
      storedProcedure: 'storedProcedure',
      isReadOnly: 'isReadOnly',
      isInlineEditable: 'isInlineEditable',
      isUpdateKeyOnImport: 'isUpdateKeyOnImport',
      isCheckFno: 'noCheckFnoUnique',
      isBatchImport: 'isBatchImport',
      parentModule: 'parentModule',
      isPage: 'isPage',
      contactSql: 'contactSql',
      listStoredProcedure: 'listStoredProcedure',
      checkStoredProcedure: 'checkStoredProcedure',
      isShowList: 'isShowList',
      isFileRequired: 'isFileRequired',
      tableImgShow: 'tableImgShow',
      formImgShow: 'formImgShow',
      isImport: 'isImport',
      isExport: 'isExport',
      isSendEmail: 'isSendEmail',
      isUploadFile: 'isUploadFile',
      isBatchModify: 'isBatchModify',
      isAboutTypography: 'isAboutTypography',
      isGlobalRetrieval: 'isGlobalRetrieval',
      tableFieldSet: 'tableFieldSet',
      formFieldSet: 'formFieldSet',
      codeEventSet: 'codeEventSet',
      languageSet: 'languageSet',
      sheetSet: 'sheetSet',
      isDbClkJump: 'isDbClkJump',
      isShowSubtotal: 'subtotal',
      showTheApprovalTab: 'showTheApprovalTab',
      passProcName: 'passProcName',
      rejectProcName: 'rejectProcName',
      pageSize: 'pageSize',
      addSuccess: 'Successfully added',
      editSuccss: 'Successfully updated',
      configFormula: 'Formula editor',
      initialization: 'initialization',



      /* 字段设置 */
      fieldShowOrder: 'fieldShowOrder',
      databaseFieldName: 'databaseFieldName',
      showName: 'showName',
      dataType: 'dataType',
      alignType: "alignType",
      queryOperator: "queryOperator",
      isSelect: 'isSelect',
      isLocked: "isLocked",
      isGlobalQuery: 'isGlobalQuery',
      isSum: 'isSum',
      isShow: 'isShow',
      dataDict: 'dataDict',
      datePrecision: "datePrecision",
      language: 'language',
      databaseFields: 'databaseFields',

      //编码设置
      save: 'save',
      year: 'year(2)',
      years: 'year(4)',
      month: 'month',
      date: 'date',
      fixedContent1: 'fixedContent1',
      fixedContent2: 'fixedContent2',
      serialNumber: 'serialNumber',
      loginId: 'loginId',
      serialNoDigit: 'serialNoDigit',
      serialNoUt: 'serialNoUt',
      pattern: 'pattern',
      formField1: 'formField1',
      formField2: 'formField2',
      formField3: 'formField3',
      formField4: 'formField4',
      formField5: 'formField5',
      smallSerialStart: 'smallSerialStart',
      bigSerial: 'big Serial',
      resetSuccess: 'Reset succeeded',
      soon: ' and ',
      strip: ' others',
      approvalChangeDel: 'approved change delete',
      exportExcel: 'export file name'
    },
    FormOfSet: {
      uploadDrag:" Drag the file here, or",
      clickUpload:'click here',
       uploadSize:'The file size does not exceed',
      add: 'add',
      fieldOrder: 'fieldOrder',
      name: 'name',
      showName: 'showName',
      defaultValue: 'defaultValue',
      expressionDecimalDigit: 'expressionDecimalDigit',
      dataType: 'dataType',
      editType: 'editType',
      formConfigId: 'formConfigId',
      isMustFill: 'isMustFill',
      isMustFillAgree: 'isMustSubmitFill',
      isManualEntry: 'isManualEntry',
      approveParam: 'approveParam',
      approveChange: 'approveChangeFile',
      combinedField: 'combinedField',
      majorKey: 'majorKey',
      isShow: 'isShow',
      isReadOnly: 'isReadOnly',
      dataDict: 'dataDict',
      remark: 'remark',
      sheet: 'sheet',
      expression: 'expression',
      clauseTemplete: 'clauseTemplete',
      widthType: 'widthType',


    },

    // 配置模块
  configMoudle: {
      ArchivingRemarks: 'Archiving Remarks',
      tableExportName: 'Table data',
      timedifference:'time difference',
      ocr: 'ocr recognition',
      nodeFinish:'node completion time',

      nodeFlow:'node flow procedure',

      waterKey:'key',

      topLeval:'top level',
      function:"select function",
      operator:'select operator',
      selectfieldName:'select field',
      clear:'clear All',

      fieldType:'field type',

      resultField:'result field',
      formulaEditor:'formula editor',

      fieldDigit:'field digit',
      fieldLength:'field length',

      characteristic:'field characteristic',

      dbname:'database name',
      fieldName:'field name',
      male:'male',
      female:'female',
      normal:'enable',
      diabled:'disable',
      signOrNot:' sign or not',
      catalogue:'catalogue',
      menu:'menu',
      button:'button',
      tableName:'table name',
      subTableName: 'child table name',
      subTable: 'child table ',
      aboutMainTable: 'main table name',
      bulkEdit:'bulkbewerking',

      portDetails:'bills details',
      headSeal: 'letterhead stamp',
      totalAll:'sum',

      noData:'No Data',

      multipleChoice:'multiple choice',

      saveFirst:'Please save first',
      uploadTypeTip:" images only in JPG or PNG format!",
      ForTrackRemark:'attention：The module and the tracking number can not be empty. Please complete the input before submitting',
      uploadSuccess:'successfully upload',
      uploadFail:'successfully upload',
      searchForTrack:'Query order number',
      addFile:'add files',
      updateFile:'change files',

      moveLineNum:'moving number',
      destLineNum:'Destination number',
      selctRowTip:' Please select the data you want to edit',
      selctRowTipDelet:' Please select the data you want to remove',
      noTotalField:'Please select the subtotal field',

      getTemplate:'get template',

      details:'details',

      forModel:'Module',
      forTrack:'Tracking number',
      serialNumber:'number',
      filesLoading:'files loading',
      filesManage:'management of files',

      noConfigTotal:'You have not configured a subtotal',
      noGroup:'please select a grouping condition',

      Financialrecognition:'finance confirm',
      FinancialCancle:' cancel finance confirm',

      noRepeat:'can not be repeated',
      shareSuccess:'shared success',
      confirmRecall:'Make sure to withdraw the current data',
      recallSucces: 'success!',
      CategoryNum:' category number',
      imageUpload:"Multiple image upload",
      selectFillter:'Enter a keyword to filter',
      inventoryNumber:'inventory number',

      confirmDelete: 'make sure to remove?',
      selectYes:"yes",
      selectNo:'no',
      transferOrder: 'Transfer Order',
      saveDefaultTemplate: 'Save default template',
      highSeasCustomers: 'High Seas Customers',
      customerMemorabilia: 'Customer Memorabilia',
      formalCustomers: 'Formal Customers',
      sendEmail: 'sendEmail',
      excelCopy: 'Excel copy',
      claim: 'claim',
      add: 'add',
      edit: 'edit',
      delete: 'delete',
      bulkEdit: 'bulkEdit',
      content: 'content',
      selectDate: 'selectDate',
      select: 'select',
      commodityTypeAdmin: 'commodityTypeAdmin',
      copyTokey: 'copy to table',
      copyToform: 'copy to form',
      parentType: 'parentType',
      TypeName: 'TypeName',
      clickUpload: 'clickUpload',
      fileView: 'fileView',
      Viewflie: 'Viewflie',
      save: 'save',
      printFormat: 'printFormat',
      cancel: 'cancel',
      print: 'print',
      billsPrint:"billsPrint",
      batchPrinting: 'batchPrinting',
      batchSubmit: 'batchSubmit',
      orderApproveByInfBatch: 'Shanghai Cross-border Export Service 9610 order',
      more: "more",
      share: 'share',
      placeOnFile: 'placeOnFile',
      personnel: 'personnel selection',
      personName: 'person name',
      classChange: 'class change',
      uploadPictures: "upload pictures",
      uploadPicture:"upload picture",

      globalQuery: 'globalQuery',
      modelName: 'modelName',
      search: 'search',
      img: 'img',
      tip: 'tip',
      tip1: 'Please enter a category name',
      tip2: 'modify successfully ',
      tip3: 'successfully added',
      tip4: 'Please select one',
      tip5: 'Are you sure you want to delete the current category and subcategories',
      tip: 'Tip',
      confirm: 'confirm',
      cancel: 'cancel',
      tip6: 'successfully delete',
      refresh: 'refresh',
      close: 'Close',
      closeLeft: 'Close Left',
      closeRight: 'Close Right',
      closeOther: 'Close others',
      closeAll: 'Close All',
      view: 'view',
      versionView: 'versionView',
      tip7: 'Only Excel format can be uploaded  ',
      tip8: 'You are not the originator of this document',
      tip9: 'The document is under approval or has been approved',
      tip10: 'You did not select a row',
      tip11: 'Do not check approved or pending rows',
      tip12: 'Select a line and then modify it',
      tip13: 'Please select one line before printing',
      tip14: 'Please select report output format!',
      tip15: 'Please select module name!',
      tip16: 'Print success',
      tip17: 'downLoad success',

      approvalHistory: 'Approval history',
      purchaseContract: 'Purchase Contract',
      supplierName:'supplier name',
      fileName:'files names',
      filePath:'files path',
      fileType:'files type',

      compilingAndbrushingLibraries: 'Compiling and brushing libraries',
      moduleName: 'moduleName',
      mainTable: 'mainTable',
      createBy: 'Create by',
      createTime: 'Create time',


      // 详情
      fetch: 'fetch',
      approval: 'approval',
      reject: 'reject',
      approvalOption: 'approvalOption',
      sendEmail: 'sendEmail',
      Examination: 'Examination',
      ExaminationSave: ' save examination',

      AnnextopurchaseContract: 'Annex to purchase Contract',
      Appendixtoexportcontract: 'Appendix to export contract',
      uploadFile: 'uploadFile',
      report: 'report',
      includeFetchSql: 'show exported data',

      includeSqlFinish: 'includeSqlFinish',
      viewLargeImg: 'viewLargeImg',
      save: 'save',
      status: 'status',
      copy: 'copy',
      topcopy: 'top Copy',
      bottomcopy: 'bottom Copy',
      moveRow: 'moveRow',
      update: 'update',
      submit: 'submit',
      recall: 'recall',
      list: 'list',
      copyInvoice: 'copyInvoice',
      tip17: 'Please select the content and click OK',
      tip18: 'The page has been refreshed. Please go to this page again and perform this operation!',
      subTotalSet: 'Subtotal config',
      openSubtotal: 'Open subtotal',
      closeSubtotal: 'Close Subtotal',
      groupCondition: 'Group Condition',
      subtotalField: 'Subtotal Field',
      notSelected: 'Not Selected',
      selected: 'Selected',
      goLeft: 'Left',
      goRight: 'Right',
      noFno: 'Cannot find this contract number, unable to jump',

      // Y-common
      linenum: 'linenum',
      batchDelete: 'batchDelete',
      replaceLineNumber: 'replaceLineNumber',
      tip19: 'The line number you entered is invalid',
      tip20: 'In approval state...',
      tip21: 'Please select the data to delete',
      tip22: 'Only one line can be selected for newline',
      tip23: 'Please select the data you want to share',
      tip24: 'Please select the data you want to archive or unarchive',
      tip25: 'Please select the person you want to share',
      tip26: 'Whether to cancel the archive？',
      tip27: "Canceling archive succeeded",
      tip28: "Archiving success",
      tipQuit: 'Make sure to quit?',
      sureToSave: 'Please click the confirm button after checking that the data is saved!',
      cancelFilter: 'cancelFilter',


      SalesContract: 'Sales Contract ',
      PurchaseContract: 'Purchase contract',
      alteration: 'alteration',
      cancelAlteration: 'cancelAlteration',
      customRegularExpressions: 'Custom Regular Expressions'
    },

    // 列表设置-----语言设置
    LanguageSet: {
      contentRequire:"language can not be empty",
      contentRequire:"content can not be empty",
      add: "add",
      language: 'language',
      content: 'content',
      operation: 'operation',
      simplifiedChinese: "simplifiedChinese",
      confirm: "confirm",
      cancel: "cancel"
    },

    // 列表设置--- sheet页设置
    SheetSetting: {
      name: 'name',
      AccordingToTheOrder: 'AccordingToTheOrder',
      add: 'add'
    },

    // 调取设置
    FetchSet: {
      sequence: 'sequence',
      add: 'add',
      name: 'name',
      targetModuleId: 'targetModuleId',
      parentModuleId: 'parentModuleId',
      targetField: 'targetField',
      isPaged: 'isPaged',
      fetchSql: 'fetchSql',
      isShowImage: 'isShowImage',
      showColumns: 'showColumns',
      isRetrieval: 'isRetrieval',
      containsCalledSQL: 'containsCalledSQL',
      edit: 'edit',
      delete: 'delete',
      languageSetting: 'languageSetting',
      tableFiledSetting: 'tableFiledSetting',
      copySetting: 'copySetting',
      fetchWarinning: 'Please fill in the retrieval statement',
      cancel: 'cancel',
      confirm: 'confirm'
    },

    // 调取设置 ---- 调取字段设置
    FetchKeySet: {
      add: 'add',
      fieldShowOrder: 'fieldShowOrder',
      databaseFieldName: 'databaseFieldName',
      showName: 'showName',
      dataType: 'dataType',
      alignType: "alignType",
      isSelect: 'isSelect',
      queryOperator: "queryOperator",
      isSortable: 'isSortable',
      isFetched: "isFetched",
      isLocked: "isLocked",
      targetField: "targetField",
      isShow: "isShow",
      datePrecision: "datePrecision",
    },


    // 首页设置
    homeSet: {
      homeSet: "homeSet",
      roleNamePlaceHolder: 'roleNamePlaceHolder',
      warningSet: 'warningSet',
      reportSet: 'reportSet',
      earlyWarning: 'earlyWarning',
      title: 'title',
      router: 'router',
      sql: 'sql',
      languageSetting: 'languageSetting',
      save: 'save',
      select: 'Please select',
      inputPlaceHolder: 'inputPlaceHolder',
      report: 'report',
      save: 'save',
      add: 'add',
      edit: 'edit',
      submitTip: 'The submitted data cannot be empty',
      saveTip: 'Save Success',
      completeTip: 'Please improve the data and save it before setting the language',
      saveFailed: 'Save Failed',
      qrSetting: 'QR code setting',
      qrUpload: 'App QR code upload',
      qrEdit: 'QR code information editing',
      qrPlaceholder: 'Please enter the information to edit',
      qrTips: 'Please upload the picture first',
      basicInfor: "basic information",
      fontConfig: "Fonts",
      passWordConfig: 'password',
      languageConfig: "language",
      fontSize: "Font size Settings",
      fontFamily: 'Font familly Settings',
      oldPassword: 'old password',
      newPassword: 'new password',
      languageSet: 'language Settings',

      defaultFont: 'default',
      smallFont: 'small',
      largeFont: 'large',
      song: 'song',
      kai: "DFKai-SB",
      yuan: 'yuan',
      shijian: 'Air',
      logoSetting: 'LogoSetting',
      companySetting: 'companyName',
      loginBackgroundSetting: 'loginBackgroundSetting',
    },

    // 报表权限设置
    ReportSet: {
      jimuReportPermissionSetting: 'jimuReportPermissionSetting',
      roleNamePlaceHolder: 'Enter a role name',
      save: 'save',
      code: 'code',
      reportName: 'reportName',
      createTime: 'createTime',
      warningTip: 'Please select at least one option',
      saveTip: 'Save Success',
      add: 'add',
      edit: 'edit',
    },

    // 字典设置
    DictSet: {
      searchButton: 'search',
      resetButton: 'reset',
      add: 'add',
      edit: 'edit',
      delete: 'delete',
      dictName: 'dictName',
      isForbidden: 'isForbidden',
      enable: 'enable',
      disAbled:"disabled",

      remark: 'remark',
      dataItemSetting: 'dataItemSetting',
      name: 'name',
      alias: 'alias',
      sortOrder: 'sortOrder',
      desc: 'desc',
      dataPermission: 'dataPermission',
    },

    // 菜单管理
    menuSet: {
      yushou:'advances received',
      permisVies:"permissions",

      menuName: 'menuName',
      search: 'search',
      reset: 'reset',
      add: 'add',
      edit: 'edit',
      delete: 'delete',
      icon: 'icon',
      type: 'type',
      orderNum: 'orderNum',
      permsCode: 'permsCode',
      remark: 'remark',
      routingPath: 'routingPath',
      menuStatus: 'menuStatus',
      addMenu: 'addMenu',
      menuType: 'menuType',
      menuIcon: 'menuIcon',
      menuIconColor: 'menuIconColor(multicolor)',
      menuVisable: 'menuVisible',
      menuOrder: 'menuOrder',
      parentCatalogue: 'parentCatalogue',
      associatedModule: 'associatedModule',
      buttonName: 'buttonName',
      language: 'language',
      deleteTip: 'Confirm deletion?',
      tip: 'Tip',
      confirm: 'confirm',
      cancel: 'cancel',
      firstSelectDelete: 'Please select before deleting',
      deleteSuccess: 'delete Success',
      action: 'operation'
    },

    // 用户管理
    userAdmin: {
      deptPlace: 'Please enter a department name',
      userName: 'userName',
      password: 'password',
      loginAccount: 'loginAccount',
      phoneNumber: 'phoneNumber',
      status: 'status',
      createTime: 'createTime',
      search: 'search',
      reset: 'reset',
      add: 'add',
      passOn: 'passOn',
      passOnPerson: 'target personnel',
      passOnMoudle:'transfer module',

      deptName: 'deptName',
      nickName: 'nickName',
      englishName: 'englishName',
      email: 'email',
      roleName: 'roleName',
      sex: 'sex',
      postId: 'postId',
      avatar: 'avatar',
      deptId: 'deptId',
      passoword: 'passoword',
      remark: 'remark',
      dept: 'dept',
      edit: 'edit',
      delete: 'delete',
      tip1: 'Select one to modify',
      loadingtip: 'Loading, please wait...',
      tip2: 'Select an item to delete',
      tip3: 'Confirm deletion?',
      tip: 'Tip',
      confirm: 'confirm',
      cancel: 'cancel',
      deleteSuccess: 'deleteSuccess!',
      editSuccess: 'editSuccess!',
      noEmpty: ' can not be empty',
      limitOfAuthority: 'limit of authority',
      synchronousAssignmentGroup: 'synchronous assignment group',
    },

    // 用户管理 --- 编辑用户
    editUserAdmin: {
      save: 'save',
      sync: 'sync',
      add: 'add',
      userInfo: 'userInfo',
      nickName: 'nickName',
      englishName: 'englishName',
      password: 'password',
      phoneNumber: 'phoneNumber',
      remark: 'remark',
      loginAccount: 'loginAccount',
      userEmail: 'userEmail',
      postId: 'postId',
      dept: 'dept',
      roleName: 'role',
      superiorLeaders: 'superiorLeaders',
      sex: 'sex',
      status: 'status',
      emailConfig: 'emailConfig',
      dataPermission: 'dataPermission',
      modelName: 'modelName',
      groupName: 'groupName',
      groupCode: 'groupCode',
      edit: 'edit',
      delete: 'delete',
      loadingtip: 'Loading, please wait...',
      saveSuccess: 'saveSuccess',
      emailUserName: 'addresserName',
      userEmail: 'addresserEmail',
      emailPassword: 'emailPassword',
      smtpHost: 'SMTPAddress',
      smtpPort: 'SMTPPort',
      signature: 'signature',
      ownPhone: 'Private mobile number',
      qq: 'QQ',
      weChat: 'WeChat',
      platformName: 'Platform Name',
      idcard: 'idcard',
      isEmailManage: 'Whether an email administrator',
      noPicture: 'no photo',

    },



    // 在线用户

    userOnline: {
      userName: 'userName',
      name: 'name',
      search: 'search',
      reset: 'reset',
      kickOut: 'kickOut',
      email: 'email',
      phone: 'phone',
      sex: 'sex',
      loginConputerIp: 'loginConputerIp',
      loginTime: 'loginTime',
      nowTime: 'nowTime',
      status: 'status',
      remark: 'remark',
      tip1: 'Confirm to kick out the user?',
      tip: 'Tip',
      confirm: 'confirm',
      cancel: 'cancel',
      tip2: 'Please select before kicking out!',
      tip3: 'User kicked out'
    },


    // 角色管理

    roleAdmin: {
      addRole:'role add',
      cancleRole:"role cancle",
      tip1: 'Are you sure you want to delete the selected role?',
      menuAllot: 'menuAllot',
      roleName: 'roleName',
      status: 'status',
      search: 'search',
      reset: 'reset',
      add: 'add',
      save: 'save',
      showSort: 'showSort',
      roleStatus: 'roleStatus',
      permissionChar: 'permissionChar',
      permissionScope: 'permissionScope',
      dataScope: 'dataScope',
      remark: 'remark',
      edit: 'edit',
      delete: 'delete',
      tip2: 'noEmpty!',
      tip3: 'Please select before deleting',
      tip4: 'Please select the menu to modify the assignment',
      tip5: 'saveSuccess'
    },


    // 部门管理
    deptAdmin: {
      deptName: 'deptName',
      status: 'status',
      search: 'search',
      reset: 'reset',
      remark: 'remark',
      add: 'add',
      deptCode: 'deptCode',
      departmentHead: 'departmentHead',
      contactWay: 'contactWay(phone)',
      showSort: 'showSort',
      createTime: 'createTime',
      addDept: 'addDept',
      superiorDepartment: 'superiorDepartment',
      edit: 'edit',
      delete: 'delete',
      tip1: 'Are you sure to delete the checked departments?',
      tip: 'Tip',
      confirm: 'confirm',
      cancel: 'cancel',
      tip2: 'Please select before deleting!',
      tip3: 'deleteSuccess'
    },

    //打印管理
    printAdmin: {
      add: 'add',
      modelNumber: 'moduleNumber',
      modelCode: 'moduleCode',
      modelId: 'moduleId',
      modelName: 'moduleName',
      mainTableName: 'mainTableName',
      reportName: 'reportName',
      idField: 'idField',
      remark: 'remark',
      edit: 'edit',
      delete: 'delete',
      tip1: 'Are you sure to delete the checked modules?',
      tip: 'Tip',
      confirm: 'confirm',
      cancel: 'cancel',
      tip2: 'Please select before deleting',
      tip3: 'deleteSuccess',
    },

    // 系统日志
  Systemlog: {
    fno: 'Number',
    tip: 'Tip',
    requestParams: 'RequestParams',
    returnParams: 'ReturnParams',
    module: 'Module',
    status: 'Status',
    message: 'Message',
    remark: 'Remark',
    createByName: 'Username',
    createTime: 'Time',
    execTime: 'Seconds',
    requestMethodName: 'RequestMethodName',
    requestIp: 'RequestIp',
    requestWay: 'RequestWay',
    bussinessType: 'BussinessType',
    cancel: 'Cancel',
    confirm: 'Confirm',
    search: 'Search',
    reset: 'Reset',
    add: 'Add',
    delete: 'Delete',
    tip1: 'Are you sure to delete the checked parameters?',
    tip2: 'Please select before deleting',
    tip3: 'DeleteSuccess'
  },

    // 模板类型
    termsTemplete: {
      add: 'add',
      templeteName: 'templeteName',
      templeteContent: 'templeteContent',
      content: 'content',
      templeteType: 'templeteType',
      createBy: 'createBy',
      createTime: 'createTime',
      updateBy: 'updateBy',
      updateTime: 'updateTime',
      selectDate: 'selectDate',
      cancel: 'cancel',
      confirm: 'confirm',
      search: 'search',
      reset: 'reset',
      delete: 'delete',
    },

    //预警设置
    warning: {
      content: 'content',
      select: 'select',
      warningTitle: 'warningTitle',
      isPage: 'isPage',
      warningSql: 'warningSql',
      CustomMenuName: 'CustomMenuName',
      remark: 'remark',
      showOrder: 'showOrder',
      isShow: 'isShow',
      cancel: 'cancel',
      confirm: 'confirm',
      add: 'add',
      edit: 'edit',
      batchDeletes: 'batchDeletes',
      delete: 'delete',
      languageSet: 'languageSet',
      warningFieldSet: 'warningFieldSet',
      tip1: 'Please select the data to delete',
      tip2: 'addSuccess',
      warningName: 'Warning name',
      emptyContent: 'Click the report name on the left to select the report',
    },
    // 预警设置---预警字段设置
    warnFieldSet: {
      databaseName: 'databaseName',
      search: 'search',
      fieldShowOrder: 'fieldShowOrder',
      datebaseField: 'datebaseField',
      showName: 'showName',
      dataType: 'dataType',
      select: 'select',
      alignType: 'alignType',
      isSelect: 'isSelect',
      QueryOperator: 'QueryOperator',
      isLock: 'isLock',
      datePrecision: 'datePrecision',
      isShow: 'isShow',
      cancel: 'cancel',
      confirm: 'confirm',
      add: 'add',
      edit: 'edit',
      languageSet: 'languageSet',
      tip1: 'Please select the data to delete',
      tip2: 'add Success',
    },


    // 流程模型
    flowModel: {
      name: 'name',
      search: 'search',
      reset: 'reset',
      add: 'add',
      flowKey: 'flowKey',
      version: 'version',
      createTime: 'createTime',
      updateTime: 'updateTime',
      metadata: 'metadata',
      edit: 'edit',
      delete: 'delete',
      upload: 'upload',
      download: 'download',
      downLoad: 'downLoad',
      addFlowModel: 'addFlowModel',
      category: 'category',
      desc: 'desc',
    },

    // 流程定义
    flowDefinition: {
      operation: 'operation',
      moduleId: 'moduleId',
      moduleName: 'moduleName',
      programmeId: 'programmeId',
      programmeName: 'programmeName',
      processDefinitionKey: 'processDefinitionKey',
      remark: 'remark',
      tip4: 'Are you sure to delete the checked modules?',
      tip5: 'Please select before deleting',
      tip6: 'saveSuccess',
      save: 'save',
      active: 'active',
      hangUp: 'hangUp',
      transferModel: 'transferModel',
      delete: 'delete',
      upload: 'upload',
      category: 'category',
      select: 'select',
      selectFile: 'selectFile',
      clickUpload: 'clickUpload',
      cancel: 'cancel',
      confirm: 'confirm',
      flowChart: 'flowChart',
      flowKey: 'flowKey',
      flowName: 'flowName',
      search: 'search',
      reset: 'reset',
      flowId: 'flowId',
      version: 'version',
      flowDesc: 'flowDesc',
      uploadTime: 'uploadTime',
      flowDefinition: 'flowDefinition',
      deploymentProcessDefinition: 'deploymentProcessDefinition',
      flowDefinitionStatus: 'flowDefinitionStatus',
      edit: 'edit',
      delete: 'delete',
      actived: 'actived',
      tip1: 'Are you sure you want to delete this process?',
      tip: 'Tip',
      confirm: 'confirm',
      cancel: 'cancel',
      tip2: 'delete Success',
      tip3: 'Please select category and submit again',
      selectModule:'select module name',
      selectProgramme:'select programme name',
      add:'add'
    },


    // 审批方案
    programmeSet: {
      name: 'name',
      search: 'search',
      reset: 'reset',
      add: 'add',
      nodeSetTip:'Please select the approval node',

      groups:'Approver Groups',
      Appoint:'Appoint the approver',
      jointTrial :"Is jointTrial ",

      nodeSet:'Approval node setting',

      programmeSetAdd:'add  programme',
      programmeSetEdit: 'edit programme',
      programmeSetName: 'programme name',
      programmeSetCode: 'programme number',
      approvalNode: 'approval node',
      version: 'version',
      createTime: 'create time',
      updateTime: 'update time',
      metadata: 'meta data',
      edit: 'edit',
      delete: 'delete',
      upload: 'deploy',
      download: 'export',
      addFlowModel: 'add flow model',
      category: 'classify',
      desc: 'describe',
    },


    // 审批
    Approval: {
      auditor:'auditor',
      backTo: 'back to node',
      tipNode: 'It will be returned to the submitter by default if you do not select ',
      tipRed: '',
      operation: 'operation',
      agree: 'agree',
      reject: 'reject',
      approveParam: 'approveParam',
      history: 'history',
      schedule: 'schedule',
      view: 'view',
      confirm: 'confirm',
      cancel: 'cancel',
      approvalOption: 'approvalOption',
      approvalProcess: 'approvalProcess',
      approvalHistory: 'approvalHistory',
      scheduleChart: 'scheduleChart',
      initiator: 'initiator',
      moduleName: 'moduleName',
      search: 'search',
      reset: 'reset',
      refresh: 'refresh',
      approvalAgree: 'approvalAgree',
      approvalReject: 'approvalRejct',
      forwarded: 'forwarded',
      approvalTime: 'approvalTime',
      // assignee: 'assignee',
      approvalParam: 'approvalParam',
      taskName: 'taskName',
      assignee: 'Approver',
      startTime: 'startTime',
      endTime: 'endTime',
      durationTime: 'durationTime',
      refreshSuccess: 'refreshSuccess',
      refressFail: 'refressFail',
      tip1: 'Please check this box before agreeing to the operation!',
      tip2: 'Please check and reject the operation!',
      viewInvoices: 'viewInvoices',
      print: 'print',
      approvalStatus: 'approvalStatus',
      tip44: 'Please fill in the approval opinion',
      initiationDate: 'Initiation date',
      save: 'save',
      fno: 'business number',
      read: 'read',
      readSuccess: 'read Success',
    },

    // 订单进度管理
    Order: {
      orderProgressTable: 'orderProgressTable',
      progress: 'progress',
      operation: 'operation',
      viewDetail: 'viewDetail',
      orderProgressChart: 'orderProgressChart',
      contractNumber: 'contractNumber',
      contractDate: 'contractDate',
      customerName: 'customerName',
      search: 'search',
      reset: 'reset',
      refresh: 'refresh',
      deliveryDate: 'deliveryDate',
      destinationPort: 'destinationPort',
      shipmentPort: 'shipmentPort',
      createBy: 'createBy',
      progress: 'progress',


      addNode: 'addNode',
      confirmNode: 'confirmNode',
      linkName: 'linkName',
      computeMode: 'computeMode',
      basisNode: 'basisNode',
      Days: 'Days',
      createDate: 'createDate',
      chargePersion: 'chargePersion',
      status: 'status',
      edit: 'edit',
      delete: 'delete',
      selectNode: 'selectNode',
      confirm: 'confirm',
      cancel: 'cancel',
      sendSuccess: 'sendSuccess',


      addNodes: 'addNodes',
      nodeName: 'nodeName',
      nodeEndCondition: 'nodeEndCondition',
      nodeEndConditionSql: 'nodeEndConditionSql',
      nodesName: 'nodesName',
      createByName: 'createByName',
      createTime: 'createTime',
      tip1: 'Are you sure you want to delete this node?',
      tip: 'Tip',
      saveSuccess: 'saveSuccess',
    },



    /* 左侧菜单 */
    Menu: {
      messageCenter: 'MessageCenter',
      nodeSettings: 'nodeSettings',
      businessFlowTracking: 'businessFlowTracking',
      SystemAdmin: 'SystemAdmin',
      home: 'home',
      ListSet: 'ListSet',
      FetchSet: 'FetchSet',
      HomeSet: 'HomeSet',
      ReportPermissSet: 'ReportPermissSet',
      dataDict: 'DataDict',
      category: 'Category',
      menuAdmin: 'MenuAdmin',
      userAdmin: 'UserAdmin',
      userOnline: 'UserOnline',
      roleAdmin: 'RoleAdmin',
      deptAdmin: 'DeptAdmin',
      printAdmin: 'PrintAdmin',
      systemLog: 'SystemLog',
      termsTemplete: 'TermsTemplete',
      warningSet: 'WarningSet',

      fieldSet: 'FieldSet',
      dataDictSet: 'DataDictSet',
      fetchFieldSet: 'FetchFieldSet',
      sheetSet: 'SheetSet',
      formSet: 'FormSet',
      codeSet: 'CodeSet',
      editUser: 'EditUser',
      languageSet: 'LanguageSet',
      versionView: 'VersionView',
      persionCenter: 'PersionCenter',
      warnPermissSet: 'WarnPermissSet',
      warning: 'Warning',
      warningFieldSet: 'WarningFieldSet',
      businessModel: 'businessModel',
      systemSet: 'SystemSettings',

      logoSet: 'logoSet',
      loginSet: 'loginBackgroundSet',

      // 流程菜单
      flowMenu: 'FlowMenu',
      flowDefinition: 'FlowDefinition',
      flowConfig: 'FlowConfig',

      flowModel: 'FlowModel',
      modelOnlineDesign: 'ModelOnlineDesign',
      addFlowConfig: 'AddFlowConfig',
      editFlowConfig: 'EditFlowConfig',
      programmeSet: 'program settings',

      // 审批管理
      approvalAdmin: 'ApprovalAdmin',
      peddingApproval: 'PeddingApproval',
      approval: 'Approval',
      Initiated: 'Initiated',
      CCRecord: 'CC record',

      // 订单进度管理
      orderProgressAdmin: 'OrderProgressAdmin',
      orderProgressList: 'OrderProgressList',
      orderNodes: 'OrderNodes',
      orderProgressDetail: 'OrderProgressDetail',
      statisticsReport: 'StatisticalReport',

      // 代码事件配置
      codeEventSet: 'codeEventSet'

    },
    // 嵌套BI系统
    Bisystem: {
      BiName: "Statistics"
    },
    StatisticalManagement: {
      StatisticalManagement: "Statistical Management",
    },
    // email
    Emails: {
      edit: 'edit',
      sign: 'signature',
      folders: 'folders',

      eName: 'EmailSystem',
      write: 'WriteEmail',
      contact: 'Contacts',
      inbox: 'Inbox',
      outbox: 'Outbox',
      drafts: 'Drafts',
      trash: 'Spam',
      folders: 'MyFolders',
      searchFolder: "search folders",
      label: 'Email Label',
      settings: 'Email Settings',
      please: 'Please Login',
      login: 'Login',
      loginsuccess: 'Login Success',
      loginfailed: 'Login Failed',
      account: 'Account',
      selectAccount: 'Account',
      signContent: 'content',
      password: 'Password',
      notnull: 'Account or password cannot be blank',
      cancel: 'Cancel',
      go: 'Go on',
      register: 'Register',
      regSuccess: 'Register Success',
      khname: 'Unit Name',
      copy: 'Copy Send',
      secret: 'Secret Send',
      addcopy: 'Add Copy Send',
      addsecret: 'Add Secret Send',
      delcopy: 'Delete Copy Send',
      delsecret: 'Delete Secret Send',
      addressee: 'Addressee',
      copyName: 'CC',
      linkTips: 'Liaison not found, please to add liaison at Contacts',
      theme: 'Theme',
      upload: 'Upload attachments',
      clearFiles: 'Clear list',
      numsTips: 'Number of attachments currently selected: ',
      uploadTips: 'Total list size: ',
      readReceipt: 'Read Receipt',
      Sender: 'Sender',
      pickSender: 'Select a sender',
      send: 'Send',
      save: 'Save',
      reset: 'Reset',
      addresseeEmpty: 'Addressee cannot be empty',
      themeEmpty: 'Theme cannot be empty',
      senderEmpty: 'Sender cannot be empty',
      senderNull: 'No sender yet, please go to Email Settings to add',
      textEmpty: 'Sending content cannot be empty',
      sendSuccess: 'Send successful',
      sendFail: 'Send failed',
      saveSuccess: 'Save successful',
      saveFail: 'Save failed',
      refresh: 'Refresh',
      themeKeyword: "Theme's keyword",
      contentKeyword: "Content's keyword",
      senderKeyword: 'Select sender',
      getAll: 'select all',
      clearAll: 'clear all',
      oneByone: 'Send a group message 1 by 1',
      generatedBy: "generated by Artificial intelligence",
      languageSet: 'language',
      transLate: 'transLate',
      promotional: 'promotional letter',
      exampleContent: 'example:Please generate a foreign trade development letter for retail industry customers for me. My name is Zhang SAN, from xxx company. Our main products and services are foreign trade software, and the target market is Southeast Asia.',
      readStatus: 'Reading status',
      addMails: "insert",
      all: 'All',
      theLastDay: 'theLastDay',
      lastThreeDays: 'Last Three Days',
      lastSevenDays: 'Last Seven Days',
      lastThirtyDays: 'Last Thirty Days',
      lastNinetyDays: 'Last Ninety Days',
      lastOneHundredEightyDays: 'Last One Hundred Eighty Days',
      unread: 'Unread',
      read: 'Read',
      removed:"removed",
      receive: 'Receive',
      delete: 'Delete',
      emailNums: 'Total email',
      emailUnread: 'Unread email',
      receiving: 'Receiving...',
      receiveFail: 'Receiving Failed',
      receiveSuccess: 'Receiving Success',
      emailDetails: 'Click to view email details',
      delTips: 'Please select before deleting',
      delSuccess: 'Deleted successfully',
      delFail: 'Deleted failed',
      contactsList: 'Contacts List',
      contactsManage: 'Contacts Manage',
      categoryManage: 'Category Manage',
      categoryName: 'Category Name',
      customerName: 'Customer Name',
      name: 'Name',
      customerCode: 'Customer Code',
      email: 'Email',
      operation: 'Operation',
      categoryParent: 'Category Parent',
      phone: 'Phone',
      reply: 'Reply',
      replyAll: 'Reply All',
      date: 'Date',
      saving: 'Save',
      pickCategory: 'Choose category',
      edit: 'Edit',
      cateTips: 'Please select one correctly',
      chooseAnItem: 'Only one option can be selected',
      writeCategoryName: 'Fill in the category name',
      nameMailTips: 'Please complete your name and email address',
      recoverySuccess: 'Recovery successful',
      recoveryFail: 'Recovery Fail',
      newFolder: 'New folder',
      editFolder: 'edit folder',

      addFolderTips: 'Please enter a folder name',
      folderName: ' folder name',

      addSuccess: 'Successfully added',
      addFail: 'Failed to add',
      emailSetting: 'Mailbox settings',
      signSetting: 'Signature settings',
      folderSetting: 'Folder settings',
      displayName: 'Display Name',
      senderName: 'Sender Name',
      copyName: 'copyName',
      emailAddress: 'E-mail address',
      addSetting: 'add',
      sendName: 'sender name',
      required: 'please fill in the ',
      requiredSelect: 'please select the ',
      selectMoveWarning: 'Please select the message you want to move',
      moveSuccess: "success",
      maveFailed: 'failed',
      sendingServer: 'Sending server',
      Authorization: 'Password',
      sendserverType: "Server type(receive)",
      serverAddress: "Server address",
      sendserverAddress: "Server address(send)",
      isDefault: 'isDefault',
      enable: 'enable',
      port: 'Port',
      sendTime: 'Sending time',

      originalMail: 'Original mail',
      receiveAll: "Receive all accounts'email",
      receiveMailPick: 'Please select the account to be charged',
      receiveMailTime: 'Please select the time period to be charged',
      receiveEmail: 'Mail receiving',
      emailNums: 'Number of emails',
      relatedModules: 'Related modules',
      moduleName: 'moduleName',
      fno: 'fno',
      selectReportFile: 'selectReportFile',
      uploaded: 'Uploaded attachments',
      uploadSuccess: 'Upload successful',
      uploadFailed: 'Upload failed',
      selectModelName: 'Please select module name',
      selectPrintFormat: 'Please select a print format',
      readTime: 'Read Time',
      readAddress: 'Address',
      readCount: 'Read Count',
      markAllAsRead: 'Mark all as read"',
      markSelectedAsRead: 'Mark selected as read',
      markAllAsReadTip: 'Are you sure you want to mark all emails as read',
      markSelectedAsReadtip: 'Are you sure you want to mark the selected emails as read',
      markedSuccess: 'Marked successfully',
      markedFail: 'Marking failed',
      moveto: 'Move to',
      emailForward: 'Forward',
      emailTemplate: 'Template',
      addTemplate: 'add Template',
      EditTemplate: 'edit Template',

      restore: 'Are you sure you want to recover this email',
      emailSet: 'MailboxConfiguration',
      noAccount: 'You have not configured an email account',
      goToSet: ' go to settings',
      singleForwarding: 'Only single forwarding is supported',
      attachments: 'Attachments',
      download: 'Download',
      cancel: 'Cancel',
      selectTheMailTemplate: 'Select the mail template',
      name: 'Name',
      defaultExpression: 'Default expression',
      receivingAccount: 'Please select a receiving account',
      pleaseSelectAnAccount: 'Please select an account',
      pleaseEnterYourSignature: 'Please enter your signature',
      pleaseFillInTheName: 'Please Fill In TheName',
      pleaseFillInTheContent: 'Please Fill In The Content',
      targetLanguage: 'Please select the target language',
      english: 'English',
      french: 'French',
      spanish: 'Spanish',
      japanese: 'Japanese',
      korean: 'Korean',
      burmese: 'Burmese',
      thai: 'Thai',
      russian: 'Russian',
      servicesProvidedByOpenai: 'Services provided by OpenAI',
    },
  // 邮件营销
  Marketing: {
    explosibility: 'Total deliverable volume',
    alreadySent: 'Total quantity issued',
    remaining: 'Residual deliverability',
    screening: 'Screening',
    reset: 'Reset',
    sendEmail: 'Send Email',
    pleaseEnterSendEmail: 'Please Enter Send Email',
    missionDataOverview: 'Mission Data Overview',
    marketingNumber: 'Marketing Number',
    sendingNumber: 'Sending Number',
    deliveryNumber: 'Delivery Number',
    unpackNumber: 'Unpack Number',
    recoverNumber: 'Recover Number',
    taskName: 'Task Name',
    add: 'Add',
    remove: 'Remove',
    selected: 'Selected',
    PCS: 'PCS',
    underWay: 'Under Way',
    complete: 'Complete',
    creationTime: 'Creation Time',
    startSending: 'Start Sending',
    sendComplete: 'Send Complete',
    lastUpdated: 'Last Updated',
    taskDeletion: 'Select the task you want to delete !',
    isDeleteCheck: 'Whether to delete selected data ?',
    tip: 'Tip',
    senderSettings: 'Sender Settings',
    contentEditing: 'Content Editing',
    sendSetting: 'Send Setting',
    taskType: 'Task Type',
    developmentLetter: 'Development Letter',
    companyIntroduction: 'Company Introduction',
    productIntroduction: 'Product Introduction',
    longTermConnection: 'Long Term Connection',
    seasonsGreetings: 'Seasons Greetings',
    other: 'Other',
    senderNickname: 'Sender Nickname',
    sendingAddress: 'Sending Address',
    sendingType: 'Sending Type',
    none: 'None',
    sendImmediately: 'Send Immediately',
    automatedMarketing: 'Automated Marketing',
    replyEmail: 'Reply Email',
    correctEmail: 'Correct Email',
    type: 'Type',
    addressee: 'Addressee',
    replyStopSending: 'Reply Stop Sending',
    readStoppedSending: 'Read Stopped Sending',
    pleaseEnter: 'PleaseEnter',
    pleaseSelect: 'PleaseSelect',
    select: 'Select',
    optional: 'Optional',
    confirm: 'Confirm',
    cancel: 'Cancel',
    lastStep: 'Last Step',
    nextStep: 'Next Step',
    immediatelyEnable: 'Immediately Enable',
    emailSubject: 'Email Subject',
    outgoingInterval: 'Outgoing Interval',
    subjectName: 'Subject Name',
    theme: 'Theme',
    controls: 'Controls',
    editor: 'Editor',
    successfulOperation: 'Successful Operation',
    successfulReplication: 'Successful Replication',
    operationFailure: 'Operation Failure',
    confirmToDelete: 'Confirm To Delete',
    mailSubjectName: 'Mail Subject Name',
    insertVariable: 'Insert Variable',
    emailContent: 'Email Content',
    uploadAttachment: 'Upload Attachment',
    commodityList: 'Commodity List',
    templateSelection: 'Template Selection',
    AILetterWriting: 'AI Letter Writing',
    AIWrite: 'AI Write',
    variable: 'Variable',
    toggle: 'Toggle',
    for: 'For',
    language: 'Language',
    english: 'English',
    french: 'French',
    spanish: 'Spanish',
    japanese: 'Japanese',
    korean: 'Korean',
    burmese: 'Burmese',
    thai: 'Thai',
    russian: 'Russian',
    outgoingInterval: 'Outgoing Interval',
    day: 'Day',
    remark: 'Remark',
    isUnsubscribe: 'With or without an unsubscribe closing',
    companyName: 'Company Name',
    languageUsed: 'The language used to output the message',
    productName: 'Product Name',
    toneOfMail: 'Tone of mail',
    business: 'Business',
    moreFormal: 'More Formal',
    politeness: 'Pliteness',
    formal: 'Formal',
    festivalName: 'Festival Name',
    wordLimit: 'Word Limit',
    unlimitedWordCount: 'Unlimited Word Count',
    intraWord: 'Intra-word',
    generalDescription: 'General Description',
    send: 'Send',
    insertIntoAMessage: 'Insert into a message',
    copyContent: 'Copy Content',
    examples: 'Example: Please generate a foreign trade development letter for retail industry customers for me, my name is Zhang SAN, from xxx company, our main products and services are foreign trade software, the target market is Southeast Asia.',
    product: 'Product',
    templateName: 'Template Name',
    hostedDataOverview: 'Hosted Data Overview',
    mailUserGrouping: 'MailUser Grouping',
    addGroup: 'Add Group',
    deleteGroup: 'Delete Group',
    serialNumber: 'Serial Number',
    userGroup: 'User Group',
    creationDate: 'Creation Date',
    instructions: 'Instructions',
    name: 'Name',
    mailbox: 'Mailbox',
    groupName: 'Group Name',
    userMailbox: 'User Mailbox',
    userGroupName: 'User group name',
    refresh: 'Refresh',
    deletingUserGroup: 'Select the user group that you want to delete !',
    isCheckDeleteUserGroup: 'Are you sure to delete the selected user group ?',
    successfullyDeleted: 'Successfully deleted !',
    saveSuccessfully: 'Save successfully !',
    success: 'Success',
    search: 'Search',
    personalTemplate: 'Personal Template',
    mailTemplateName: 'Mail Template Name',
    privatelyOwned: 'Privately Owned',
    publicity: 'Publicity',
    isPublicTemplate: 'Is Public Template',
    templateTopic: 'Template Topic',
    templateContent: 'Template Content',
    templateRemarks: 'Template Remarks',
    saveTemplate: 'Save Template',
    NOTranslationPicture: 'Cannot translate content containing images !',
    marketingTask: 'Marketing Task',
    setbasicInformation: 'Set basic information',
    submitScheme: 'Submit and confirm the proposal',
    trusteeshipScheme: 'A solution that requires hosting',
    view: 'View',
    edit: 'Edit',
    addCustomScheme: 'Add Custom Scheme',
    outgoingMailbox: 'Outgoing Mailbox',
    replyEmail: 'Reply Email',
    recipientEmailAddress: 'Recipient Email Address',
    industry: 'Industry',
    textile: 'Textile',
    homeFurnishings: 'Home Furnishings',
    mailLanguage: 'Mail Language',
    confirmationMarketingLetter: 'Please confirm the marketing letter',
    tip1001: 'Customer development through multiple rounds of marketing, each with a different focus and an automatic, timed message to the recipient who did not respond',
    startCircularMarketing: 'Start Circular Marketing',
    change: 'Change',
    addScheme: 'Add Scheme',
    schemeName: 'Scheme Name',
    templateLibrary: 'Template Library',
    generateTemplate: 'Generate Template',
    intervalTime: 'Interval Time',
    triggerCondition: 'Trigger Condition',
    NoReplyYet: 'No Reply Yet',
    unread: 'Unread',
    translation: 'Translate into the target language',
    description: 'Description',
    save: 'Save',
    isGenerateRemplate: 'Whether to generate a template ?',
    addSuccessfully: 'Add Successfully',
    generateNewScheme: 'Modify content Will a new solution be generated after enabling it ?',
    mailTemplate: 'Mail Template',
    addTemplate: 'Add Template',
    updateTime: 'Update Time',
    personalTemplate: 'Personal Template',
    commonTemplate: 'Common Template',
  }
}
